/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { savePdfResponse } from "utils/documentPdf";
import { useCatalogueAccountOptions } from "utils/catalogueAccounts";
import { ClearableSearchInput } from "components/SearchField/SearchField";
import CatalogueItemDialog from "components/CatalogueItemDialog";
import CatalogueItemDropdown from "components/CatalogueItemDropdown";
import AddItemDialog from "layouts/Items/AddItemDialog";
import useLineItemReorder from "hooks/useLineItemReorder";
import useDraftDocumentState from "hooks/useDraftDocumentState";
import useUnsavedChanges from "hooks/useUnsavedChanges";
import useBillingDocumentNumber from "hooks/useBillingDocumentNumber";
import { clearBillingNumberPreview } from "utils/billingNumberPreview";
import useDocumentNumberValidation from "hooks/useDocumentNumberValidation";
import { Add, ArrowDropDown } from "@mui/icons-material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import {
  memo,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import DataTable from "react-data-table-component";
import validator from "validator";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { appConstants } from "utils/appConstants";
import {
  convertToTitleCase,
  formatDateWithCurrentTimeForPickDate,
  getScreenRight,
  showResMsg,
  validateField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import {
  SaveInvoice,
  UpdateInvoice,
  getInvoiceDetailsByID,
  getItemsForInvoice,
  getQuotationsForInvoice,
  ResendEmail,
} from "utils/invoiceAPI";
import {
  getContactsForQuotation,
  getQuotationDetailsByID,
} from "utils/quotationAPI";
import useFeatureAccess from "utils/useFeatureAccess";
import { loadingAction } from "ReduxReducers/loadingReducer";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { paymentTermsOptions } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { AllKeysHaveValue } from "utils/generic";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import useTableStyles from "styles/customStyleItemTable";
import { getCurrencyValue } from "utils/generic";
import { calculateAmounts } from "utils/generic";
import { calculatePrice } from "utils/generic";
import {
  addCatalogueItemData,
  getCurrencyCode,
  downloadInvoice,
  fetchInvoicePdfTheme,
} from "utils/api";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { calculateInvoiceTotals } from "utils/invoiceCalculations";
import { sanitizeQuantityInputValue } from "utils/numberInputConstraints";
import { resolvePreviewReturn } from "utils/previewReturn";
import {
  createPendingAttachment,
  uploadPendingAttachments,
} from "utils/documentAttachments";
import { formatNumberWithCommas } from "utils/formatCurrency";
import {
  LuArrowLeft,
  LuCalendar,
  LuCamera,
  LuCheck,
  LuChevronDown,
  LuDownload,
  LuEye,
  LuFileText,
  LuGripVertical,
  LuInfo,
  LuPaperclip,
  LuPencil,
  LuPlus,
  LuSave,
  LuSearch,
  LuSend,
  LuTrash2,
  LuUpload,
} from "react-icons/lu";
import AppHeader from "components/AppHeader";
import { DashboardNavigation } from "layouts/businessUserDashboard";
import "./invoiceFlow.css";
import "layouts/Quotation/quotation.css";
import "./invoiceEditorTheme.css";
import InvoiceSelect from "components/FormControls/ThemedSelect";
import InvoiceCustomerDialog from "./InvoiceCustomerDialog";
import CustomerInvoicePreview from "./CustomerInvoicePreview";
import SendInvoiceModal from "./SendInvoiceModal";
import { showDraftSavedMessage } from "components/InlineFeedback/DraftSaveConfirmation";
import InvoiceAttachmentPreview from "./InvoiceAttachmentPreview";
import DocumentPreviewSkeleton from "components/Skeleton/DocumentPreviewSkeleton";
import PageSkeleton from "components/Skeleton/PageSkeleton";
import RecordInvoicePaymentDialog from "./RecordInvoicePaymentDialog";
import {
  feedbackBus,
  InlineFormMessage,
} from "components/InlineFeedback/InlineFeedback";

const SCREEN_NAME = "Invoices";
const MAX_VISIBLE_ITEM_ROWS = 4;
const EMPTY_ITEM_ROW = {
  itemID: "",
  itemName: "",
  itemPrice: "",
  itemDescription: "",
  categoryCodeName: "",
  itemQuantity: 1,
  gst: 10,
  discountType: "None",
  discountValue: "",
  discountAmount: 0,
  totalItemPrice: 0,
};
const EMPTY_CATALOGUE_ITEM = {
  itemName: "",
  itemCode: "",
  itemDescription: "",
  itemPrice: "",
  categoryCodeName: "200 - Sales",
  status: "Active",
  unit: "each",
  defaultQuantity: 1,
  gst: 10,
  discountType: "None",
  discountValue: "",
};
const createEmailTemplateValues = () => ({
  screenType: "Invoices",
  userEmailAddress: "",
  customerEmailAddress: [],
  emailTemplate: "",
});
let SCREEN_RIGHT;
const pdfStyle = {
  boxShadow: 24,
  p: 4,
  top: "50%",
  left: "50%",
  width: "90%",
  height: "90%x",
  position: "absolute",
  border: "2px solid #000",
  bgcolor: "background.paper",
  transform: "translate(-50%, -50%)",
};
const tableCardStyle = { width: "100%" };
let routePath = "";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const OCR_UPLOAD_ENDPOINT = "/ocr-api/invoice/extract";
const OCR_MAX_FILE_SIZE = 20 * 1024 * 1024;
const OCR_SUPPORTED_TYPES = new Set([
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/webp",
]);

const getQuotationItemDescription = (item) => {
  const normalize = (value) =>
    String(value || "")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();
  const name = normalize(item.itemName);
  return name && normalize(item.itemDescription) === name
    ? ""
    : item.itemDescription || "";
};

const ocrValue = (field) => {
  if (
    field &&
    typeof field === "object" &&
    Object.prototype.hasOwnProperty.call(field, "value")
  ) {
    return field.value;
  }
  return field;
};

const firstOcrValue = (...fields) => {
  for (const field of fields) {
    const value = ocrValue(field);
    if (value !== undefined && value !== null && value !== "") return value;
  }
  return "";
};

const getOcrItemText = (item) => {
  const descriptionField = item.itemDescription ?? item.description;
  const description = String(firstOcrValue(descriptionField) || "").trim();
  if (item.name !== undefined || item.itemName !== undefined) {
    return {
      itemName: String(firstOcrValue(item.name, item.itemName) || "").trim(),
      itemDescription: description,
    };
  }

  // Older OCR responses combine the title and description in one field.
  const evidence = Array.isArray(descriptionField?.evidence)
    ? descriptionField.evidence
    : [];
  const regions = evidence
    .filter((entry) => entry.text?.trim() && entry.polygon?.length)
    .map((entry) => {
      const top = Math.min(...entry.polygon.map((point) => point.y));
      const bottom = Math.max(...entry.polygon.map((point) => point.y));
      return {
        text: entry.text.trim(),
        page: entry.page,
        top,
        height: Math.max(1, bottom - top),
        left: Math.min(...entry.polygon.map((point) => point.x)),
      };
    })
    .sort((a, b) => a.page - b.page || a.top - b.top || a.left - b.left);
  const lines = [];
  regions.forEach((region) => {
    const previous = lines[lines.length - 1];
    if (
      previous &&
      previous.page === region.page &&
      Math.abs(previous.top - region.top) <=
        Math.max(previous.height, region.height) * 0.6
    ) {
      previous.text += ` ${region.text}`;
    } else {
      lines.push({ ...region });
    }
  });
  const textLines = lines.length
    ? lines.map((line) => line.text)
    : description
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
  return {
    itemName: textLines[0] || "",
    itemDescription: textLines.slice(1).join("\n"),
  };
};

const ocrNumber = (...fields) => {
  const value = firstOcrValue(...fields);
  if (value === "") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  const numericText = String(value).replace(/[^0-9.-]/g, "");
  if (
    !numericText ||
    numericText === "-" ||
    numericText === "." ||
    numericText === "-."
  )
    return null;
  const parsed = Number(numericText);
  return Number.isFinite(parsed) ? parsed : null;
};

const normalizeOcrText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const parseOcrDate = (field) => {
  const value = firstOcrValue(field);
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

  const text = String(value).trim();
  const dayFirst = text.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{2}|\d{4})$/);
  if (dayFirst) {
    const year = Number(
      dayFirst[3].length === 2 ? `20${dayFirst[3]}` : dayFirst[3]
    );
    const parsed = new Date(year, Number(dayFirst[2]) - 1, Number(dayFirst[1]));
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }

  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const ocrEntityValue = (entity, keys) => {
  if (!entity) return "";
  if (typeof entity !== "object") return ocrValue(entity) || "";
  return firstOcrValue(...keys.map((key) => entity[key]), entity.value);
};

const getInvoiceDraftItemErrors = (rows) =>
  rows.map((row, index) => {
    const name = String(row.itemName || "").trim();
    const desc = String(row.itemDescription || "").trim();
    const hasContent = Boolean(
      name || desc || row.itemID || String(row.itemPrice ?? "").trim()
    );
    if (!hasContent && rows.length > 1 && index > 0) return {};
    const errors = {};
    if (!name && !desc) {
      errors.itemName = "Enter an item name or description.";
    }
    if (!String(row.itemPrice ?? "").trim()) {
      errors.itemPrice = "Enter a unit price.";
    } else if (
      !Number.isFinite(Number(row.itemPrice)) ||
      Number(row.itemPrice) < 0
    ) {
      errors.itemPrice = "Enter 0 or more.";
    }
    if (
      !Number.isFinite(Number(row.itemQuantity)) ||
      Number(row.itemQuantity) <= 0
    ) {
      errors.itemQuantity = "Must be > 0.";
    }
    return errors;
  });

async function handleApiResponse({
  isUpdate,
  values,
  setOpen,
  showResMsg,
  navigate,
  handleSoftDismisal,
  setShowBillingModal,
  dispatch,
  redirectToOutside,
  InvoiceID,
  setValues,
  setIsPreviewMode,
  onSendResult,
  saveAttachments,
  onSaved,
  onNumberError,
}) {
  const apiFunction = isUpdate ? UpdateInvoice : SaveInvoice;
  return apiFunction(
    values,
    async (data) => {
      if (data?.Result_Status) {
        clearBillingNumberPreview("invoice", values.businessUserID);
        const attachmentWarnings = data.Result_Output?.attachmentWarnings || [];
        const saveConfirmation = attachmentWarnings.length
          ? `Draft saved successfully. ${attachmentWarnings.join(" ")}`
          : undefined;
        const confirmationType = attachmentWarnings.length
          ? "warning"
          : "success";
        const targetId =
          data.Result_Output?._id || InvoiceID || values.invoiceID;
        const assignedNo =
          data.Result_Output?.invoiceNumber || values.invoiceNumber;
        values.invoiceID = targetId;
        values.invoiceNumber = assignedNo;
        setValues((previous) => ({
          ...previous,
          invoiceID: targetId,
          invoiceNumber: assignedNo,
        }));
        if (saveAttachments && !(await saveAttachments(targetId))) {
          if (typeof onSendResult === "function")
            onSendResult({
              success: false,
              targetId,
              message:
                "Draft saved, but attachment upload failed. Save again to retry.",
            });
          return;
        }
        onSaved?.();
        if (
          attachmentWarnings.length &&
          (typeof onSendResult === "function" ||
            redirectToOutside === "prepareSend")
        ) {
          showDraftSavedMessage(saveConfirmation, confirmationType);
        }
        if (typeof onSendResult === "function") {
          const emailPayload = {
            selectedID: targetId,
            businessUserID: values.businessUserID,
            userEmailAddress: values.templateValues?.userEmailAddress,
            customerEmailAddress: values.templateValues?.customerEmailAddress,
            emailTemplate: values.templateValues?.emailTemplate,
            sendMeCopy: values.templateValues?.sendMeCopy,
            attachPdf: values.templateValues?.attachPdf,
            screenType: values.templateValues?.screenType || "Invoices",
          };
          values.sendEmailFlag = false;
          return ResendEmail(
            emailPayload,
            (result) => {
              onSendResult({
                success: Boolean(result?.Result_Status),
                targetId,
                assignedNo,
                message:
                  result?.Result_Message ||
                  "Invoice saved, but email could not be sent.",
              });
            },
            dispatch
          );
        }
        setOpen(false);
        if (!isUpdate && values.sendEmailFlag) {
          const emailPayload = {
            selectedID: targetId,
            businessUserID: values.businessUserID,
            userEmailAddress: values.templateValues?.userEmailAddress,
            customerEmailAddress: values.templateValues?.customerEmailAddress,
            emailTemplate: values.templateValues?.emailTemplate,
            sendMeCopy: values.templateValues?.sendMeCopy,
            attachPdf: values.templateValues?.attachPdf,
            screenType: values.templateValues?.screenType || "Invoices",
          };
          values.sendEmailFlag = false;
          return ResendEmail(
            emailPayload,
            (result) => {
              showResMsg(
                result?.Result_Message || "Invoice created.",
                2000,
                Boolean(result?.Result_Status),
                navigate,
                "/invoices"
              );
            },
            dispatch
          );
        }
        values.sendEmailFlag = false;
        if (redirectToOutside === "redirectToItemWhenSave") {
          navigate(`/items/addItems?new=invoice&id=${targetId}`);
        } else if (redirectToOutside === "redirectToEditItemWhenSave") {
          const itemId = sessionStorage.getItem("ItemIdForItemEdit");
          sessionStorage.removeItem("ItemIdForItemEdit");
          navigate(
            `/items/editItem/itemid=${itemId}?source=invoice&id=${targetId}`
          );
        } else if (
          redirectToOutside === "preview" ||
          redirectToOutside === "stayInPreview"
        ) {
          setIsPreviewMode(true);
          showDraftSavedMessage(saveConfirmation, confirmationType);
        } else if (["prepareSend", "saveAndExit", "saveAndLeave"].includes(redirectToOutside)) {
          // Keep the editor in place for the send dialog or guarded navigation.
        } else {
          showDraftSavedMessage(saveConfirmation, confirmationType);
          if (!InvoiceID && targetId)
            navigate(`/invoices/edit/${targetId}`, { replace: true });
        }
      } else {
        values.sendEmailFlag = false;
        if (onNumberError?.(data)) {
          onSendResult?.({ success: false, field: "invoiceNumber" });
          return;
        }
        if (typeof onSendResult === "function") {
          onSendResult({
            success: false,
            message: data?.Result_Message || "The invoice could not be saved.",
          });
          return;
        }
        if (data?.Result_Message === "ALREADY_EXIST_PO")
          return handleSoftDismisal();
        if (data?.Result_Output === "NO AVAILABLE CREDITS")
          setShowBillingModal(true);
        showResMsg(
          data?.Result_Message || "The invoice draft could not be saved.",
          2000,
          false
        );
      }
    },
    dispatch,
    { showLoader: false }
  );
}

function AddInvoice() {
  const featureAccess = useFeatureAccess();
  const customStyles = useTableStyles();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: InvoiceID } = useParams();
  let type = new URLSearchParams(window.location.search).get("type");
  const [isPreviewMode, setIsPreviewMode] = useState(
    new URLSearchParams(location.search).get("mode") === "preview"
  );

  const [savedTargetId, setSavedTargetId] = useState(InvoiceID || null);
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [hasEditedInvoice, setHasEditedInvoice] = useState(false);
  const [isSendingInvoice, setIsSendingInvoice] = useState(false);
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
  const invoiceImportInputRef = useRef(null);
  const invoiceCameraInputRef = useRef(null);
  const [hasStartedInvoiceImport, setHasStartedInvoiceImport] = useState(false);
  const [invoiceImport, setInvoiceImport] = useState({
    status: "idle",
    fileName: "",
    message: "",
    warnings: [],
    requestId: "",
  });

  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
  );
  const [previewBusinessProfile, setPreviewBusinessProfile] = useState(null);
  const [previewLogoFileName, setPreviewLogoFileName] = useState("");
  const [previewIdentityLoading, setPreviewIdentityLoading] = useState(true);

  useEffect(() => {
    if (!isPreviewMode) {
      setPreviewIdentityLoading(false);
      return undefined;
    }
    setPreviewIdentityLoading(true);
    const userId =
      loginDetails?._id ||
      sessionStorage.getItem("USER_ID")?.replace(/["']/g, "").trim();
    let active = true;
    const profileRequest = userId
      ? axios
          .post(
            `${appConstants.baseURL}user/fetchUserProfile`,
            { _id: userId },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
              },
            }
          )
          .then(({ data }) => {
            if (!active) return;
            const output = data?.Result_Output;
            setPreviewBusinessProfile(
              Array.isArray(output) ? output[0] || null : output || null
            );
          })
          .catch(() => {})
      : Promise.resolve();
    const logoRequest = loginDetails?.businessUserID
      ? axios
          .post(`${appConstants.baseURL}defaultSettings/fetchDefaultSetting`, {
            businessUserID: loginDetails.businessUserID,
          })
          .then(({ data }) => {
            if (active) {
              const output = data?.Result_Output;
              const settings = Array.isArray(output)
                ? output[0] || {}
                : output || {};
              setPreviewLogoFileName(
                settings.defaultLogoFileName || ""
              );
            }
          })
          .catch(() => {})
      : Promise.resolve();
    Promise.all([profileRequest, logoRequest])
      .catch(() => {})
      .finally(() => {
        if (active) setPreviewIdentityLoading(false);
      });
    return () => {
      active = false;
    };
  }, [isPreviewMode, loginDetails?._id, loginDetails?.businessUserID]);
  const catalogueAccountOptions = useCatalogueAccountOptions(
    loginDetails?.businessUserID
  );
  const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
  const [invoiceNoErr, setInvoiceNoErr] = useState(false);
  const numberValidation = useDocumentNumberValidation("invoice", "invoice-number-input");
  const [contactNameErr, setContactNameErr] = useState(false);
  const [isCustomerDropdownOpen, setIsCustomerDropdownOpen] = useState(false);
  const [draftValidationAttempted, setDraftValidationAttempted] =
    useState(false);
  const [draftValidationField, setDraftValidationField] = useState(null);
  const [draftSaveError, setDraftSaveError] = useState("");
  const [contactDetails, setContactDetails] = useState([]);
  const [canManageCustomers, setCanManageCustomers] = useState(false);
  const [customerAction, setCustomerAction] = useState(null);

  const [quotationDetails, setQuotationDetails] = useState([]);
  const [screenName, setScreenName] = useState("Add New Invoice");
  const [typeQuotation, setTypeQuotation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialPageLoading, setInitialPageLoading] = useState(
    Boolean(InvoiceID)
  );
  const [showSendEmailBtn, setShowSendEmailBtn] = useState(false);
  const [showItemAndDocumentSection, setShowItemAndDocumentSection] =
    useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [itemsDetails, setItemsDetails] = useState([]);
  const [masterItemDetails, setMasterItemDetails] = useState([]);
  const [activeItemDropdownIdx, setActiveItemDropdownIdx] = useState(null);
  const [itemSearchQueries, setItemSearchQueries] = useState({});
  const itemDropdownRefs = useRef({});
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [editingCatalogueItem, setEditingCatalogueItem] = useState(null);
  const [isItemSaving, setIsItemSaving] = useState(false);
  const [newItemForm, setNewItemForm] = useState(() => ({
    ...EMPTY_CATALOGUE_ITEM,
  }));
  const [itemModalError, setItemModalError] = useState("");
  const [fileError, setFileError] = useState("");
  const [itemModalTargetIdx, setItemModalTargetIdx] = useState(null);
  const [itemRowValues, setItemRowValues] = useState(() => [
    { ...EMPTY_ITEM_ROW },
  ]);
  const [itemsViewportHeight, setItemsViewportHeight] = useState(null);
  const itemsTableBodyRef = useRef(null);
  const pendingItemsScrollRef = useRef(null);
  const [quotationLoaded, setQuotationLoaded] = useState(false);

  const [usedRetentionAmount, setUsedRetentionAmount] = useState(0);
  const [finalise, setFinalise] = useState(false);
  const showAddNewCustomer = !finalise;
  const [scheduleRetention, setScheduleRetention] = useState(false);
  const [deleteItemFlag, setDeleteItemFlag] = useState(false);
  const [retentionItemValues, setRetentionItemValues] = useState([]);
  const retentionItemValuesRef = useRef(retentionItemValues);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("");
  const [showInvoicePaymentLink, setShowInvoicePaymentLink] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  // Document and email state.
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState(
    createEmailTemplateValues
  );

  const [values, setValues] = useState({
    token: token,
    businessUserID: loginDetails?.businessUserID,
    invoiceID: undefined,
    userID: loginDetails?._id,
    invoiceNumber: "",
    invoiceNumberEdited: false,
    invoiceType: "Direct",
    contactID: "",
    quotationID: "",
    purchaseOrderNumber: "",
    invoiceDate: new Date(new Date() - new Date().getTimezoneOffset() * 60000),
    dueDate: new Date(new Date() - new Date().getTimezoneOffset() * 60000),
    dueUpto: "Same Day",
    invoiceStatus: "Unpaid",
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    totalGSTAmount: 0,
    finalAmount: 0,
    paymentInstruction: "",
    scopeNotes: "",
    terms: "",
    documentName: "",
    sendEmailFlag: false,
  });
  const [quoDocuments, setDocuments] = useState([]);
  const draftSaveRef = useRef(false);
  const [currencyCode, setCurrencyCode] = useState("");

  // Hooks derived from the editor state.
  const itemReorder = useLineItemReorder({
    rows: itemRowValues,
    setRows: setItemRowValues,
    setSearchQueries: setItemSearchQueries,
    closeSearch: () => setActiveItemDropdownIdx(null),
    disabled: isSavingDraft || isSendingInvoice || finalise,
    idPrefix: "invoice",
    darkMode,
  });
  const invoiceNumber = useBillingDocumentNumber({
    type: "invoice",
    documentID: InvoiceID || values.invoiceID,
    businessUserID: loginDetails?.businessUserID,
    setValues,
  });
  const draftDocument = useDraftDocumentState({
    type: "invoice",
    id: InvoiceID || values.invoiceID,
    values,
    items: itemRowValues,
    documents: quoDocuments,
    saving: isSavingDraft || isSendingInvoice,
  });
  const saveAndExitRef = useRef(null);
  const unsavedChanges = useUnsavedChanges(
    draftDocument.hasUnsavedChanges &&
      (hasEditedInvoice ||
        Boolean(values.quotationID) ||
        quoDocuments.some((document) => document.file)),
    {
      documentName: "invoice",
      isExistingDraft: Boolean(InvoiceID || values.invoiceID),
      canSaveDraft: !finalise,
      onSave: () => handleSaveInvoice("saveAndLeave"),
    }
  );
  const allDraftItemErrors = useMemo(
    () => getInvoiceDraftItemErrors(itemRowValues),
    [itemRowValues]
  );
  const formattedCreationDate = useMemo(() => {
    const date = new Date(values.createdDate || values.createdAt || Date.now());
    return Number.isNaN(date.getTime())
      ? "—"
      : date.toLocaleDateString("en-AU", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
  }, [values.createdDate, values.createdAt]);

  // Editor synchronization and layout effects.
  useEffect(() => {
    const paginationLabel = document
      .getElementsByClassName("rdt_Pagination")[0]
      ?.getElementsByTagName("span")[0];
    if (paginationLabel) paginationLabel.textContent = "Records Per Page";

    document.querySelectorAll(".dayHour").forEach((element) => {
      element.style.color = darkMode ? "white" : "black";
    });
  });

  useEffect(() => {
    setIsPreviewMode(
      new URLSearchParams(location.search).get("mode") === "preview"
    );
  }, [location.search]);
  useEffect(() => {
    let active = true;
    setCanManageCustomers(false);
    if (showAddNewCustomer && loginDetails?.businessUserID) {
      getScreenRight("Contacts")
        .then((right) => {
          if (active) setCanManageCustomers(right === "Full Access");
        })
        .catch(() => {
          if (active) setCanManageCustomers(false);
        });
    }
    return () => {
      active = false;
    };
  }, [showAddNewCustomer, loginDetails?.businessUserID]);
  useLayoutEffect(() => {
    const tableBody = itemsTableBodyRef.current;
    if (!tableBody || itemRowValues.length <= MAX_VISIBLE_ITEM_ROWS) {
      setItemsViewportHeight(null);
      return undefined;
    }

    const visibleRows = Array.from(tableBody.children).slice(
      0,
      MAX_VISIBLE_ITEM_ROWS
    );
    const updateViewportHeight = () => {
      const height = visibleRows.reduce(
        (total, row) => total + row.getBoundingClientRect().height,
        0
      );
      if (height > 0) setItemsViewportHeight(Math.ceil(height));
    };

    updateViewportHeight();
    window.addEventListener("resize", updateViewportHeight);
    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(updateViewportHeight)
        : null;
    visibleRows.forEach((row) => resizeObserver?.observe(row));

    return () => {
      window.removeEventListener("resize", updateViewportHeight);
      resizeObserver?.disconnect();
    };
  }, [itemRowValues.length]);

  useLayoutEffect(() => {
    const tableBody = itemsTableBodyRef.current;
    const scrollTarget = pendingItemsScrollRef.current;
    if (!tableBody || !scrollTarget) return undefined;

    pendingItemsScrollRef.current = null;
    const animationFrame = window.requestAnimationFrame(() => {
      const top = scrollTarget === "bottom" ? tableBody.scrollHeight : 0;
      if (typeof tableBody.scrollTo === "function") {
        tableBody.scrollTo({
          top,
          behavior:
            scrollTarget === "bottom" &&
            !window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
              ? "smooth"
              : "auto",
        });
      } else {
        tableBody.scrollTop = top;
      }
    });
    return () => window.cancelAnimationFrame(animationFrame);
  }, [itemRowValues.length]);

  useEffect(() => {
    var element = document.getElementsByTagName("fieldset");
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var disabledval = document.querySelectorAll(".Mui-disabled");
    var dropicons = document.querySelectorAll(".MuiInputBase-root");
    for (let i = 0; i < element.length; i++) {
      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < disabledval.length; i++) {
      var usevalue = disabledval[i].getElementsByTagName("input");

      if (usevalue.length > 0) {
        if (darkMode) {
          usevalue[0].style.setProperty(
            "-webkit-text-fill-color",
            "white",
            "important"
          );
        } else {
          usevalue[0].style.removeProperty("-webkit-text-fill-color");
        }
      }
    }

    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName("svg");
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill:");
        }
      }
    }
  }, [itemRowValues, expanded]);

  useEffect(() => {
    const HoldQuotationData = JSON.parse(
      sessionStorage.getItem("HoldQuotationData")
    );

    if (HoldQuotationData) {
      setValues((prevValues) => ({
        ...prevValues,

        businessUserID: HoldQuotationData.businessUserID || "",
        contactID: HoldQuotationData.contactID || "",
        invoiceDate: HoldQuotationData.invoiceDate || "",
        dueUpto: HoldQuotationData.dueUpto || "",
        dueDate: HoldQuotationData.dueDate || "",
        // quotationNumber: HoldQuotationData.quotationNumber || "",
        finalAmount: HoldQuotationData.finalAmount || "0.00",
        totalAmount: HoldQuotationData.totalAmount || "0.00",
        totalDiscountAmount: HoldQuotationData.totalDiscountAmount || "0.00",
        totalGSTAmount: HoldQuotationData.totalGSTAmount || "0.00",
        name: HoldQuotationData.name || "",
        gstType: HoldQuotationData.gstType || "Inclusive",
        invoiceStatus: HoldQuotationData.invoiceStatus || "Pending",
        purchaseOrderNumber: HoldQuotationData.purchaseOrderNumber || "",
        paymentInstruction: HoldQuotationData.paymentInstruction || "",
        scopeNotes: HoldQuotationData.scopeNotes || "",
        terms: HoldQuotationData.terms || "",
      }));
    }
  }, []);

  useEffect(() => {
    const filtered = itemRowValues.filter((item) =>
      Boolean(
        item.itemID || item.itemName?.trim() || item.itemDescription?.trim()
      )
    );
    if (filtered.length > 0) {
      setShowSendEmailBtn(
        filtered.every(
          (row) =>
            Boolean(row.itemName?.trim() || row.itemDescription?.trim()) &&
            row.itemPrice &&
            row.itemQuantity
        )
      );
    } else {
      setShowSendEmailBtn(false);
    }
  }, [itemRowValues]);

  useEffect(() => {
    if (values.invoiceType === "Through Quotation" && values.quotationID) {
      setTypeQuotation(true);
    } else {
      setTypeQuotation(false);
    }
  }, [values.invoiceType, values.quotationID]);

  useEffect(() => {
    const paramValue = new URLSearchParams(window.location.search).get(
      "status"
    );

    switch (paramValue) {
      case "debt":
        routePath = "/debts";
        break;
      default:
        routePath = "/invoices";
        break;
    }
  }, [dispatch]);

  const fetchData = async () => {
    if (InvoiceID) setInitialPageLoading(true);
    try {
      setScreenName(
        InvoiceID
          ? type !== "clone"
            ? "Edit Invoice"
            : "Clone Invoice "
          : "Add New Invoice"
      );
      setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

      // Saved invoice details are the critical path for both the editor and
      // preview. Do not hold that request behind contacts/currency lookups.
      await Promise.all([
        getRight(),
        LoadInitialData(),
        fetchCurrencyValue(),
        loadInvoiceDetails(),
      ]);
    } catch (error) {
      console.error("Error in useEffect:", error);
    } finally {
      if (InvoiceID) setInitialPageLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const itemFromUrl = new URLSearchParams(window.location.search).get("item");
    if (itemFromUrl) {
      const selectedItem = masterItemDetails.find(
        (item) => item._id === itemFromUrl
      );
      const alreadyItemAdded = itemRowValues.some(
        (item) => item.itemID === itemFromUrl
      );
      if (!alreadyItemAdded && selectedItem) {
        const newItemValue = { value: itemFromUrl };
        const emptyRowIndex = itemRowValues.findIndex(
          (row) => !row.value && row.value !== undefined && row.value !== null
        );
        const targetIndex =
          emptyRowIndex !== -1 ? emptyRowIndex : itemRowValues.length - 1;
        handleItemRow("", newItemValue, targetIndex);
      }
    }
    if (
      JSON.stringify(retentionItemValues) !==
      JSON.stringify(retentionItemValuesRef.current)
    ) {
      retentionItemValuesRef.current = retentionItemValues;
      const sum = retentionItemValues.reduce(
        (acc, curr) =>
          parseFloat(acc) + parseFloat(curr.retentionPaymentAmount || 0),
        0
      );
      setUsedRetentionAmount(sum);
    }
  }, [retentionItemValues, masterItemDetails]);

  useEffect(() => {
    const contactFromUrl = new URLSearchParams(window.location.search).get(
      "contact"
    );
    if (!contactFromUrl) return;
    if (contactFromUrl === "add-new") {
      handleChangeCustomer("name")("", {
        label: "Add New Customer",
        value: "add-new",
      });
      return;
    }
    const selectedContact = contactDetails.find(
      (contact) => contact._id === contactFromUrl
    );
    if (selectedContact) {
      handleChangeCustomer("name")("", {
        label: selectedContact.companyName,
        value: contactFromUrl,
      });
    }
  }, [contactDetails]);

  useEffect(() => {
    const labelTextSpans = document.querySelectorAll(
      "label.MuiFormControlLabel-root span.MuiTypography-root"
    );
    labelTextSpans.forEach((span) => {
      span.style.color = darkMode ? "white" : "#1ed6ca";
    });
  }, [darkMode, tableBorder]);

  useEffect(() => {
    if (!quotationLoaded || !masterItemDetails.length) return;
    const itemId = new URLSearchParams(window.location.search).get("item");
    if (!itemId) return;
    const selectedItem = masterItemDetails.find((item) => item._id === itemId);
    if (!selectedItem) return;
    const urlItemRow = {
      itemID: selectedItem._id,
      itemName: selectedItem.itemName,
      itemDescription: selectedItem.itemDescription || "",
      categoryCodeName: selectedItem.categoryCodeName,
      itemPrice: Number(selectedItem.itemPrice),
      itemQuantity: Number(selectedItem.itemQuantity),
      gst: selectedItem.gst,
      discountType: selectedItem.discountType,
      discountValue: selectedItem.discountValue,
      discountAmount: 0,
      totalItemPrice:
        Number(selectedItem.itemPrice) * Number(selectedItem.itemQuantity),
    };
    setItemRowValues((previous) => {
      const rowsWithoutEmpty = previous.filter(
        (row) =>
          row.itemID || row.itemName?.trim() || row.itemDescription?.trim()
      );
      if (rowsWithoutEmpty.some((row) => row.itemID === itemId)) {
        return previous;
      }
      return [...rowsWithoutEmpty, urlItemRow];
    });
  }, [quotationLoaded, masterItemDetails]);

  useEffect(() => {
    if (itemRowValues.length) handleCalculation(values.gstType);
  }, [itemRowValues, values.gstType]);

  const draftItemErrors = allDraftItemErrors.map((errors, index) => {
    const field = Object.keys(errors).find(
      (name) =>
        draftValidationField ===
        `invoice-${name === "itemName" ? "item-search" : name}-${index}`
    );
    return field ? { [field]: errors[field] } : {};
  });
  const draftRecipientEmail = String(
    values.recipientEmail ??
      contactDetails.find(
        (contact) => String(contact._id) === String(values.contactID)
      )?.emailAddress ??
      ""
  ).trim();
  const draftRecipientEmailError = !draftRecipientEmail
    ? "Recipient email cannot be empty."
    : !validator.isEmail(draftRecipientEmail)
    ? "Please enter a valid email address, e.g. accounts@example.com."
    : "";
  const draftDateError =
    !values.invoiceDate || Number.isNaN(new Date(values.invoiceDate).getTime())
      ? "Choose a valid invoice date."
      : "";
  const draftDueDateError =
    !values.dueDate || Number.isNaN(new Date(values.dueDate).getTime())
      ? "Choose a valid due date."
      : !draftDateError &&
        dayjs(values.dueDate)
          .startOf("day")
          .isBefore(dayjs(values.invoiceDate).startOf("day"))
      ? "Due date cannot be before the invoice date."
      : "";

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
  }

  let fetchCurrencyValue = async () => {
    await getCurrencyCode(
      { businessUserID: values.businessUserID },
      (data) => {
        if (data.Result_Status) {
          setCurrencyCode(data.Result_Output);
        }
      },
      dispatch
    );
  };

  const LoadInitialData = async () => {
    try {
      const bUserId =
        values.businessUserID ||
        loginDetails?.businessUserID ||
        JSON.parse(sessionStorage.getItem("LOGIN_DETAILS") || "{}")
          ?.businessUserID;

      const [customerList, quotationList] = await Promise.all([
        new Promise((resolve, reject) => {
          getContactsForQuotation(
            { businessUserID: bUserId },
            resolve,
            dispatch
          );
        }),
        new Promise((resolve, reject) => {
          getQuotationsForInvoice(
            { businessUserID: bUserId, invoiceID: InvoiceID },
            resolve,
            dispatch
          );
        }),
      ]);
      if (customerList?.Result_Output?.length > 0) {
        setContactDetails(customerList.Result_Output);
      }
      if (quotationList?.Result_Status) {
        setQuotationDetails(quotationList.Result_Output || []);
      }

      // If opening New Invoice from Quotation (/invoices/add?quotationID=...)
      const queryParams = new URLSearchParams(
        location.search || window.location.search
      );
      const targetQuotationID =
        queryParams.get("quotationID") ||
        queryParams.get("quotationId") ||
        location.state?.quotationID;

      if (!InvoiceID && targetQuotationID) {
        let targetQuote = quotationList?.Result_Output?.find(
          (item) => String(item._id) === String(targetQuotationID)
        );

        if (!targetQuote) {
          try {
            const fetched = await new Promise((resolve) => {
              getQuotationDetailsByID(
                { quotationID: targetQuotationID, businessUserID: bUserId },
                resolve,
                dispatch
              );
            });
            if (fetched?.Result_Status && fetched?.Result_Output?.length > 0) {
              targetQuote = fetched.Result_Output[0];
            }
          } catch (fetchErr) {
            console.error("Error fetching quotation details:", fetchErr);
          }
        }

        if (targetQuote) {
          const custId =
            targetQuote.contactID?._id ||
            targetQuote.contactID ||
            targetQuote.customerID;
          const matchedContact = customerList?.Result_Output?.find(
            (c) => String(c._id) === String(custId)
          );
          const contactPaymentTerms =
            targetQuote.validUpto || matchedContact?.paymentTerms || "14 Days";
          const todayDate = new Date();
          let calculatedDueDate = new Date();
          try {
            calculatedDueDate =
              calculateDueUpto(contactPaymentTerms, todayDate) || new Date();
          } catch (e) {
            calculatedDueDate = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
          }

          setValues((prev) => ({
            ...prev,
            invoiceType: "Through Quotation",
            throughQuotation: true,
            quotationID: targetQuote._id,
            quotationNumber: targetQuote.quotationNumber,
            contactID: custId ? String(custId) : prev.contactID,
            contactName:
              targetQuote.name ||
              matchedContact?.companyName ||
              prev.contactName,
            recipientEmail:
              targetQuote.recipientEmail ||
              location.state?.quotation?.recipientEmail ||
              targetQuote.customerEmailAddress ||
              matchedContact?.emailAddress ||
              prev.recipientEmail,
            purchaseOrderNumber:
              targetQuote.purchaseOrderNumber || prev.purchaseOrderNumber,
            gstType: targetQuote.gstType || prev.gstType || "Inclusive",
            totalAmount: Number(targetQuote.totalAmount) || 0,
            totalDiscountAmount: Number(targetQuote.totalDiscountAmount) || 0,
            totalGSTAmount: Number(targetQuote.totalGSTAmount) || 0,
            finalAmount: Number(targetQuote.finalAmount) || 0,
            scopeNotes: targetQuote.scopeNotes || prev.scopeNotes || "",
            paymentInstruction:
              targetQuote.paymentInstruction || prev.paymentInstruction,
            terms: targetQuote.terms || prev.terms,
            invoiceDate: todayDate,
            dueUpto: contactPaymentTerms,
            dueDate: calculatedDueDate,
          }));

          if (targetQuote.items?.length > 0) {
            const mappedItems = targetQuote.items.map((it) => ({
              itemID: it.itemID?._id || it.itemID || it._id || "",
              itemName: it.itemName || "",
              itemDescription: getQuotationItemDescription(it),
              itemPrice: it.itemPrice ?? 0,
              itemQuantity: it.itemQuantity ?? 1,
              categoryCodeName: it.categoryCodeName || "Sales",
              gst: it.gst ?? 10,
              discountType: it.discountType || "None",
              discountValue: it.discountValue ?? "",
              discountAmount: it.discountAmount ?? 0,
              totalItemPrice:
                it.totalItemPrice ??
                Number(it.itemPrice || 0) * Number(it.itemQuantity || 1),
            }));
            setItemRowValues(mappedItems);
          }

          if (targetQuote.quotationDocuments?.length > 0) {
            setDocuments(targetQuote.quotationDocuments);
          }

          setTypeQuotation(true);
        }
      }
    } catch (error) {
      console.error("Error getting Invoice Details: ", error.message);
    }
  };
  const loadInvoiceDetails = async () => {
    try {
      let detailsPromise;
      const requestValues = {
        ...values,
        invoiceID: InvoiceID || values.invoiceID,
      };
      const itemsPromise = new Promise((resolve, reject) => {
        getItemsForInvoice(
          requestValues,
          (data) => {
            if (data?.Result_Status === false) {
              reject(
                new Error(
                  data.Result_Message || "Could not load catalogue items."
                )
              );
              return;
            }
            const items = data?.Result_Output || [];
            setItemsDetails(items);
            setMasterItemDetails(items);
            resolve();
          },
          dispatch
        );
      });

      if (InvoiceID) {
        detailsPromise = new Promise((resolve, reject) => {
          getInvoiceDetailsByID(
            requestValues,
            (data) => {
              const result = data?.Result_Output?.[0];
              if (data?.Result_Status && result) {
                const resultIsSent =
                  Number(result.emailSent) > 0 ||
                  /^(sent|viewed|issued)$/i.test(result.activityStatus || "");
                if (resultIsSent && !isPreviewMode) {
                  showResMsg(
                    "Sent invoices cannot be edited. Opened invoice details instead.",
                    2200,
                    false
                  );
                  navigate(`/invoices/view/${InvoiceID}`, { replace: true });
                  resolve();
                  return;
                }
                setFinalise(result.emailSent > 0);
                setValues((previous) => ({ ...previous, ...result }));
                const apiItems = result.items || [];
                draftDocument.markSaved({ ...values, ...result }, apiItems);

                setQuotationLoaded(true);

                if (result.items?.length > 0) {
                  setItemRowValues(apiItems);
                } else {
                  setItemRowValues([{ ...EMPTY_ITEM_ROW }]);
                }

                if (result.invoiceDocuments?.length > 0) {
                  setDocuments(result.invoiceDocuments);
                }
                resolve();

                if (result.retentions?.length > 0) {
                  setScheduleRetention(true);
                  setRetentionItemValues(result.retentions);

                  const flagItem = result.retentions.some(
                    (item) => item.retentionStatus === "Paid"
                  );
                  setDeleteItemFlag(flagItem);
                }
                setShowInvoicePaymentLink(result.showPaymentSection);
              } else {
                showResMsg(
                  data?.Result_Message || "No invoice details found.",
                  2000,
                  false
                );
                navigate("/invoices");
                reject(new Error("No invoice details found"));
              }
            },
            dispatch
          );
        });
      } else {
        dispatch(loadingAction(false));
      }
      await Promise.all([itemsPromise, detailsPromise]);
    } catch (error) {
      console.error("Error loading invoice details:", error);
    }
  };

  const handleChangeApprovedQuotation = (name) => (event, newValue) => {
    if (newValue) {
      const selectedItem = quotationDetails.find(
        (quotation) => quotation._id === newValue.id
      );
      console.log("selsctItem", selectedItem);
      if (selectedItem) {
        const quotationPaymentTerms = selectedItem.validUpto || "14 Days";
        const quotationDueDate =
          calculateDueUpto(quotationPaymentTerms, values.invoiceDate) ||
          values.dueDate;
        setValues({
          ...values,
          [name]: selectedItem.quotationNumber,
          quotationID: newValue.id,

          contactID: selectedItem.contactID,
          recipientEmail:
            selectedItem.recipientEmail ||
            contactDetails.find(
              (contact) =>
                String(contact._id) === String(selectedItem.contactID)
            )?.emailAddress ||
            "",
          gstType: selectedItem.gstType,
          finalAmount: selectedItem.finalAmount,
          paymentInstruction: selectedItem.paymentInstruction,
          purchaseOrderNumber: selectedItem.purchaseOrderNumber,
          totalAmount: selectedItem.totalAmount,
          totalDiscountAmount: selectedItem.totalDiscountAmount,
          dueUpto: quotationPaymentTerms,
          dueDate: quotationDueDate,
        });
        setItemRowValues(
          selectedItem.items.map((item) => ({
            ...item,
            itemDescription: getQuotationItemDescription(item),
          }))
        );
        setDocuments(selectedItem.quotationDocuments);
        // setShowItemAndDocumentSection(true);
      }
    } else {
      setValues({ ...values, [name]: "", quotationID: "" });
    }
  };
  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function calculateDueUpto(paymentTerms, invoiceDate) {
    try {
      const currentDate = new Date(invoiceDate);

      switch (paymentTerms) {
        case "Same Day":
          return currentDate;
        case "7 Days":
          return addDays(currentDate, 7);

        case "14 Days":
          return addDays(currentDate, 14);

        case "30 Days":
          return addDays(currentDate, 30);

        case "14 Days End of Month":
          return addDays(endOfMonth(currentDate), 14);

        case "30 Days End of Month":
          return addDays(endOfMonth(currentDate), 30);

        default:
          throw new Error("Invalid payment term");
      }
    } catch (error) {
      console.error("calculateDueUpto Error", error);
    }
  }

  const handleValidUptoDate = (paymentTerms) => {
    try {
      const dueDate = calculateDueUpto(paymentTerms, values.invoiceDate);
      setValues((prevValues) => ({
        ...prevValues,
        dueDate: dueDate,
        dueUpto: paymentTerms,
      }));
    } catch (error) {
      console.error("handleValidUptoDate Error", error);
    }
  };
  const handleChangeCustomer = (name) => (event, newValue) => {
    if (newValue?.value !== "add-new") setHasEditedInvoice(true);
    if (newValue?.value !== "add-new" && draftValidationField === "invoice-customer-input") {
      setDraftSaveError("");
      setDraftValidationField(null);
    }
    setTemplateValues(createEmailTemplateValues());
    if (newValue) {
      if (newValue.value === "add-new") {
        setIsCustomerDropdownOpen(false);
        if (canManageCustomers) {
          setCustomerAction({ action: "create", contact: null });
        } else {
          showResMsg(genericMessage.notPermission, 2000, false);
        }
      } else {
        setContactNameErr(false);
        setIsCustomerDropdownOpen(false);
        const customer = contactDetails.find(
          (c) => String(c._id) === String(newValue.value)
        );
        const paymentTerms = customer?.paymentTerms || "30 Days End of Month";
        handleValidUptoDate(paymentTerms);
        setValues((prevValues) => ({
          ...prevValues,
          [name]: newValue.label,
          contactID: newValue.value,
          recipientEmail:
            customer?.emailAddress ||
            customer?.customerEmailAddress ||
            customer?.email ||
            prevValues.recipientEmail ||
            "",
        }));
      }
    } else {
      setValues((prev) => ({
        ...prev,
        [name]: "",
        contactID: "",
        recipientEmail: "",
      }));
      setContactNameErr(false);
    }
  };
  const handleCustomerAction = (action, id) => {
    if (
      !canManageCustomers ||
      !showAddNewCustomer ||
      finalise ||
      isSavingDraft ||
      isSendingInvoice
    )
      return;
    const contact = contactDetails.find(
      (customer) => String(customer._id) === String(id)
    );
    if (contact) setCustomerAction({ action, contact });
  };

  const handleCustomerUpdated = (customer) => {
    const previous = contactDetails.find(
      (contact) => String(contact._id) === String(customer._id)
    );
    setContactDetails((contacts) =>
      contacts.map((contact) =>
        String(contact._id) === String(customer._id) ? customer : contact
      )
    );
    setValues((current) =>
      String(current.contactID) === String(customer._id)
        ? {
            ...current,
            name: customer.companyName || customer.name,
            recipientEmail:
              !current.recipientEmail ||
              current.recipientEmail === previous?.emailAddress
                ? customer.emailAddress
                : current.recipientEmail,
          }
        : current
    );
    if (String(values.contactID) === String(customer._id)) {
      setTemplateValues(createEmailTemplateValues());
    }
  };

  const handleCustomerCreated = (customer) => {
    setContactDetails((contacts) => [
      customer,
      ...contacts.filter(
        (contact) => String(contact._id) !== String(customer._id)
      ),
    ]);
    setContactNameErr(false);
    setValues((current) => ({
      ...current,
      name: customer.companyName || customer.name,
      contactID: customer._id,
      recipientEmail: customer.emailAddress || "",
      dueUpto: customer.paymentTerms || "14 Days",
    }));
    handleValidUptoDate(customer.paymentTerms || "14 Days");
    setTemplateValues(createEmailTemplateValues());
  };

  const handleCustomerDeleted = (id) => {
    setContactDetails((contacts) =>
      contacts.filter((contact) => String(contact._id) !== String(id))
    );
    if (String(values.contactID) === String(id)) {
      handleChangeCustomer("name")(null, null);
      setValues((current) => ({ ...current, recipientEmail: "" }));
      setContactNameErr(false);
    }
  };
  const handleValidUpto = (name) => (event) => {
    setHasEditedInvoice(true);
    if (name === "dueUpto") {
      handleValidUptoDate(event.target.value);
    }
  };
  //Handle Save or Update Quotation Function
  const handleChange = (name) => (event) => {
    setHasEditedInvoice(true);
    let value = event.target.value;

    if (name === "gstType") {
      setValues((prev) => ({ ...prev, gstType: value }));
    } else if (name === "contactID" && value === "add_new") {
      if (canManageCustomers) {
        setCustomerAction({ action: "create", contact: null });
      } else {
        showResMsg(genericMessage.notPermission, 2000, false);
      }
    } else if (
      name === "invoiceType" &&
      value === "Through Quotation" &&
      quotationDetails.length <= 0
    ) {
      swal({
        icon: "warning",
        text: "Please proceed with Direct Invoice Type.",
        title: "There is no Approved Quotation Available!",
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    } else if (name === "invoiceType" && value === "Direct") {
      if (values.quotationID) {
        ShowSwalWithButtons(
          `Are you sure, you want to change Invoice Type.`,
          `Changing Invoice Type to 'Direct' will clear all quotation-related fields. Are you sure you want to continue?`,
          "warning",
          darkMode,
          () => {
            setValues({
              ...values,
              [name]: event.target.value,
              quotationID: "",
              quotationNumber: "",
              contactID: "",
              gstType: "",
              finalAmount: "",
              paymentInstruction: "",
              purchaseOrderNumber: "",
              totalAmount: "",
              totalDiscountAmount: "",
            });
            setItemRowValues([]);
            setDocuments([]);
            // setShowItemAndDocumentSection(false);
          }
        );
      } else setValues({ ...values, [name]: value, quotationID: "" });
    } else if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  };

  const handleExistingInvoiceUpload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    const extensionAllowed = /\.(pdf|png|jpe?g|webp)$/i.test(file.name);
    if (
      (!OCR_SUPPORTED_TYPES.has(file.type) && !extensionAllowed) ||
      file.size === 0
    ) {
      setInvoiceImport({
        status: "error",
        fileName: file.name,
        message:
          file.size === 0
            ? "The selected file is empty."
            : "Choose a PDF, PNG, JPEG, or WEBP invoice.",
        warnings: [],
        requestId: "",
      });
      return;
    }

    if (file.size > OCR_MAX_FILE_SIZE) {
      setInvoiceImport({
        status: "error",
        fileName: file.name,
        message: "The invoice must be 20 MB or smaller.",
        warnings: [],
        requestId: "",
      });
      return;
    }

    setHasStartedInvoiceImport(true);
    setInvoiceImport({
      status: "loading",
      fileName: file.name,
      message:
        "Reading the invoice. Large or scanned documents can take a few minutes.",
      warnings: [],
      requestId: "",
    });

    const form = new FormData();
    form.append("file", file);
    form.append("language", "en");
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 360000);

    try {
      const response = await fetch(OCR_UPLOAD_ENDPOINT, {
        method: "POST",
        body: form,
        signal: controller.signal,
      });
      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        const detail = Array.isArray(result.detail)
          ? result.detail
              .map((entry) => entry.msg)
              .filter(Boolean)
              .join(" ")
          : result.detail;
        const busyMessage =
          response.status === 429
            ? "The invoice reader is busy. Wait a moment and try again."
            : "Invoice extraction failed.";
        throw new Error(detail || busyMessage);
      }

      const extracted = result.invoice || {};
      if (extracted.documentType === "quotation") {
        throw new Error(
          "This file is a quotation. Create the invoice from the quotation flow instead."
        );
      }
      const warnings = Array.isArray(extracted.warnings)
        ? [...extracted.warnings]
        : [];
      const lowConfidence = [];
      const trackConfidence = (label, field) => {
        if (
          field &&
          typeof field === "object" &&
          Number(field.confidence) < 0.85
        ) {
          lowConfidence.push(
            `${label} has low confidence and should be checked.`
          );
        }
      };

      trackConfidence("Invoice number", extracted.invoiceNumber);
      trackConfidence("Invoice date", extracted.invoiceDate);
      trackConfidence("Booking reference", extracted.bookingReference);
      trackConfidence("Currency", extracted.currency);

      const customerName = ocrEntityValue(extracted.customer, [
        "name",
        "companyName",
        "legalName",
      ]);
      const customerEmail = ocrEntityValue(extracted.customer, [
        "email",
        "emailAddress",
      ]);
      const customerAbn = ocrEntityValue(extracted.customer, [
        "abn",
        "abnNumber",
        "taxId",
      ]);
      const normalizedCustomerName = normalizeOcrText(customerName);
      const normalizedCustomerEmail = normalizeOcrText(customerEmail);
      const normalizedCustomerAbn = normalizeOcrText(customerAbn);
      const matchedCustomer = contactDetails.find((contact) => {
        const names = [
          contact.companyName,
          contact.name,
          `${contact.firstName || ""} ${contact.lastName || ""}`,
        ]
          .map(normalizeOcrText)
          .filter(Boolean);
        return (
          (normalizedCustomerAbn &&
            normalizeOcrText(contact.abnNumber) === normalizedCustomerAbn) ||
          (normalizedCustomerEmail &&
            normalizeOcrText(contact.emailAddress) ===
              normalizedCustomerEmail) ||
          (normalizedCustomerName && names.includes(normalizedCustomerName))
        );
      });

      if (customerName && !matchedCustomer) {
        warnings.push(
          `Customer “${customerName}” was not matched. Select an existing customer or add a new customer using the extracted details.`
        );
      }

      const importedDate = parseOcrDate(extracted.invoiceDate);
      const importedDueDate = parseOcrDate(
        firstOcrValue(extracted.dueDate, extracted.settlementDate)
      );
      const paymentTerms =
        matchedCustomer?.paymentTerms ||
        values.dueUpto ||
        "30 Days End of Month";
      const calculatedDueDate =
        importedDueDate ||
        (importedDate ? calculateDueUpto(paymentTerms, importedDate) : null);
      const sourceReference = firstOcrValue(
        extracted.bookingReference,
        extracted.invoiceNumber
      );
      const importedCurrency = String(
        firstOcrValue(extracted.currency) || ""
      ).toUpperCase();
      if (
        importedCurrency &&
        currencyCode &&
        importedCurrency !== String(currencyCode).toUpperCase()
      ) {
        warnings.push(
          `The invoice currency is ${importedCurrency}; this draft uses ${currencyCode}.`
        );
      }

      const gstText = String(
        firstOcrValue(extracted.gstType) || ""
      ).toLowerCase();
      const importedGstType = gstText.includes("exclusive")
        ? "Exclusive"
        : gstText.includes("inclusive")
        ? "Inclusive"
        : values.gstType;
      const totals = extracted.totals || {};
      const subtotal = ocrNumber(
        totals.subtotal,
        totals.subTotal,
        totals.net,
        totals.netAmount
      );
      const totalTax = ocrNumber(
        totals.gst,
        totals.tax,
        totals.taxTotal,
        totals.totalTax,
        totals.gstAmount
      );
      const grandTotal = ocrNumber(
        totals.total,
        totals.grandTotal,
        totals.amountDue,
        totals.invoiceTotal
      );
      const discountTotal = ocrNumber(
        totals.discount,
        totals.discountTotal,
        totals.totalDiscount
      );

      const extractedItems = Array.isArray(extracted.items)
        ? extracted.items
        : [];
      const importedRows = extractedItems
        .map((item) => {
          const { itemName, itemDescription } = getOcrItemText(item);
          const itemCode = String(
            firstOcrValue(item.code, item.itemCode, item.sku) || ""
          ).trim();
          const quantity = ocrNumber(item.quantity, item.qty) || 1;
          const lineTotal = ocrNumber(item.total, item.lineTotal, item.amount);
          const unitPrice =
            ocrNumber(item.unitPrice, item.price, item.rate) ??
            (lineTotal !== null ? lineTotal / quantity : 0);
          const gst = ocrNumber(item.gst, item.taxRate, item.gstRate);
          const discountAmount =
            ocrNumber(item.discountAmount, item.discount) || 0;
          const normalizedName = normalizeOcrText(itemName);
          const normalizedCode = normalizeOcrText(itemCode);
          const catalogueItem = masterItemDetails.find(
            (candidate) =>
              (normalizedCode &&
                normalizeOcrText(candidate.itemCode) === normalizedCode) ||
              (normalizedName &&
                [candidate.itemName, candidate.itemDescription]
                  .map(normalizeOcrText)
                  .includes(normalizedName))
          );

          return {
            ...EMPTY_ITEM_ROW,
            itemID: catalogueItem?._id || "",
            itemName: itemName || catalogueItem?.itemName || "",
            itemDescription,
            categoryCodeName: catalogueItem?.categoryCodeName || "Sales",
            itemPrice: unitPrice,
            itemQuantity: quantity,
            gst:
              gst ??
              (catalogueItem?.gst !== undefined
                ? Number(catalogueItem.gst)
                : 10),
            discountType: discountAmount > 0 ? "Fixed" : "None",
            discountValue: discountAmount > 0 ? discountAmount : "",
            discountAmount,
            totalItemPrice:
              lineTotal ?? Math.max(0, unitPrice * quantity - discountAmount),
            ocrImported: true,
          };
        })
        .filter(
          (item) => item.itemName || item.itemDescription || item.itemPrice
        );

      const unmatchedItems = importedRows.filter((item) => !item.itemID).length;
      if (unmatchedItems > 0) {
        warnings.push(
          `${unmatchedItems} imported line item${
            unmatchedItems === 1 ? "" : "s"
          } must be matched to catalogue items before saving.`
        );
      }

      setTemplateValues({
        screenType: "Invoices",
        userEmailAddress: "",
        customerEmailAddress: [],
        emailTemplate: "",
      });
      setValues((current) => ({
        ...current,
        contactID:
          matchedCustomer?._id ||
          (customerName || customerEmail ? "" : current.contactID),
        name:
          matchedCustomer?.companyName ||
          matchedCustomer?.name ||
          customerName ||
          (customerEmail ? "" : current.name),
        recipientEmail:
          customerEmail ||
          matchedCustomer?.emailAddress ||
          (customerName ? "" : current.recipientEmail),
        purchaseOrderNumber: sourceReference || current.purchaseOrderNumber,
        invoiceDate: importedDate || current.invoiceDate,
        dueDate: calculatedDueDate || current.dueDate,
        dueUpto: paymentTerms,
        gstType: importedGstType,
        totalAmount:
          subtotal !== null ? subtotal.toFixed(2) : current.totalAmount,
        totalDiscountAmount:
          discountTotal !== null
            ? discountTotal.toFixed(2)
            : current.totalDiscountAmount,
        totalGSTAmount:
          totalTax !== null ? totalTax.toFixed(2) : current.totalGSTAmount,
        finalAmount:
          grandTotal !== null ? grandTotal.toFixed(2) : current.finalAmount,
      }));
      if (importedRows.length > 0) {
        setItemRowValues(importedRows);
        setItemSearchQueries({});
        setActiveItemDropdownIdx(null);
      }

      const populatedFields =
        [
          customerName || matchedCustomer,
          customerEmail,
          sourceReference,
          importedDate,
          importedDueDate,
          subtotal,
          totalTax,
          grandTotal,
        ].filter(
          (value) => value !== null && value !== undefined && value !== ""
        ).length + importedRows.length;
      setInvoiceImport({
        status: "success",
        fileName: file.name,
        message:
          populatedFields > 0
            ? `Invoice read successfully. ${populatedFields} draft value${
                populatedFields === 1 ? " was" : "s were"
              } imported for review.`
            : "The document was read, but no reliable invoice fields were found.",
        warnings: [...new Set([...warnings, ...lowConfidence])],
        requestId: result.request_id || extracted.importId || "",
      });
    } catch (error) {
      const message =
        error.name === "AbortError"
          ? "Invoice extraction timed out after six minutes. Try again or enter the invoice manually."
          : error.message || "Invoice extraction failed.";
      setInvoiceImport({
        status: "error",
        fileName: file.name,
        message,
        warnings: [],
        requestId: "",
      });
    } finally {
      window.clearTimeout(timeout);
    }
  };

  const clearAllErrorMsg = () => {
    setContactNameErr(false);
    setInvoiceNoErr(false);
  };

  function identifyMissingItems(itemRowValues) {
    let missingItems = [];
    itemRowValues.forEach((row, index) => {
      const hasNameOrDesc = Boolean(
        String(row.itemName || "").trim() ||
          String(row.itemDescription || "").trim()
      );
      if (!hasNameOrDesc || !row.itemPrice || !row.itemQuantity) {
        missingItems.push(index + 1);
      }
    });

    if (missingItems.length === 0) {
      return "All items are filled in.";
    }

    let missingItemsMessage =
      "Please fill in all of the following items before creating the invoice:\n";
    missingItems.forEach((itemIndex) => {
      missingItemsMessage += `Row ${itemIndex}: `;
      const row = itemRowValues[itemIndex - 1];
      const hasNameOrDesc = Boolean(
        String(row.itemName || "").trim() ||
          String(row.itemDescription || "").trim()
      );
      if (!hasNameOrDesc) {
        missingItemsMessage += "Enter an item name or description, ";
      }
      if (!row.itemPrice) {
        missingItemsMessage += "Item Price, ";
      }
      if (!row.itemQuantity) {
        missingItemsMessage += "Item Quantity, ";
      }

      missingItemsMessage = missingItemsMessage.slice(0, -2); // Remove the last comma and space
      missingItemsMessage += "\n";
    });

    return missingItemsMessage;
  }

  const validateInvoiceDraft = () => {
    setDraftValidationAttempted(true);
    const customerMissing = !values.contactID;
    setContactNameErr(customerMissing);
    if (customerMissing) {
      setIsCustomerDropdownOpen(true);
    }
    const numberMissing = Boolean(
      (InvoiceID || values.invoiceID) &&
        !String(values.invoiceNumber || "").trim()
    );
    const invalidItemIndex = allDraftItemErrors.findIndex(
      (errors) => Object.keys(errors).length
    );
    if (
      !customerMissing &&
      !draftRecipientEmailError &&
      !draftDateError &&
      !draftDueDateError &&
      !numberMissing &&
      invalidItemIndex < 0
    ) {
      setDraftValidationField(null);
      setInvoiceNoErr(false);
      return true;
    }
    const itemField =
      invalidItemIndex >= 0
        ? Object.keys(allDraftItemErrors[invalidItemIndex])[0]
        : "";
    const firstInvalidID = customerMissing
      ? "invoice-customer-input"
      : draftRecipientEmailError
      ? "invoice-recipient-email"
      : draftDateError
      ? "invoice-date-input"
      : draftDueDateError
      ? "invoice-due-date-input"
      : numberMissing
      ? "invoice-number-input"
      : itemField === "itemName"
      ? `invoice-item-search-${invalidItemIndex}`
      : `invoice-${itemField}-${invalidItemIndex}`;
    setDraftValidationField(firstInvalidID);
    setDraftSaveError(
      customerMissing
        ? "Please select a customer."
        : draftRecipientEmailError ||
            draftDateError ||
            draftDueDateError ||
            (numberMissing ? "Invoice number is required." : "") ||
            (invalidItemIndex >= 0
              ? `Item ${invalidItemIndex + 1}: ${
                  allDraftItemErrors[invalidItemIndex][itemField]
                }`
              : "Correct the highlighted fields before saving.")
    );
    setInvoiceNoErr(firstInvalidID === "invoice-number-input");
    window.requestAnimationFrame(() => {
      const input = document.getElementById(firstInvalidID);
      input?.focus({ preventScroll: true });
      input?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    return false;
  };

  const handleSaveInvoice = async (
    redirectToOutside = null,
    onSendResult = null,
    afterSaved = null
  ) => {
    setDraftValidationAttempted(true);
    setDraftSaveError("");
    if (draftSaveRef.current) return;
    if (["draft", "saveAndLeave"].includes(redirectToOutside)) values.sendEmailFlag = false;
    if (
      draftDocument.canUseDocumentActions &&
      (!redirectToOutside || ["draft", "saveAndLeave"].includes(redirectToOutside)) &&
      !values.sendEmailFlag &&
      typeof onSendResult !== "function"
    ) {
      showDraftSavedMessage("Draft is already saved.");
      if (redirectToOutside === "saveAndLeave") unsavedChanges.markSaved();
      afterSaved?.();
      return;
    }
    if (!validateInvoiceDraft()) {
      if (typeof onSendResult === "function")
        onSendResult({
          success: false,
          message: "Correct the highlighted fields before saving.",
        });
      return;
    }
    draftSaveRef.current = true;
    setIsSavingDraft(true);

    try {
      type && (values.type = type);
      const pricing = calculateInvoiceTotals(
        itemRowValues,
        values.gstType || "Inclusive"
      );
      const isThroughQuotation = Boolean(
        typeQuotation || values.throughQuotation || values.quotationID
      );
      clearAllErrorMsg();
      let mandateFlag = false;

      let invoiceDate = new Date(values.invoiceDate);
      invoiceDate.setUTCHours(0, 0, 0, 0);

      let dueDate = new Date(values.dueDate);
      dueDate.setUTCHours(23, 59, 59, 999);

      if (dueDate <= invoiceDate) {
        if (typeof onSendResult === "function") {
          onSendResult({
            success: false,
            message: "Due date should be more than Invoice date",
          });
        }
        return showResMsg(
          "Due date should be more than Invoice date",
          2000,
          false
        );
      }
      if (values.contactID === "") {
        mandateFlag =
          validateField(values.contactID, setContactNameErr) || mandateFlag;
        if (typeof onSendResult === "function") {
          onSendResult({
            success: false,
            message: "Please select a customer first",
          });
        }
        return;
      }

      values.invoiceID = InvoiceID ? InvoiceID : values.invoiceID;

      if (InvoiceID) {
        values.scheduleRetention = scheduleRetention;
        if (scheduleRetention) {
          if (pricing.finalAmount > parseFloat(usedRetentionAmount)) {
            Swal.fire({
              icon: "warning",
              title: "You have pending the Retention Amount.",
              text: "You have chosen the Schedule Retention. To proceed, please complete all Retention Limit Amounts",
              customClass: {
                confirmButton: "swal-button swal-button--confirm-green",
                popup: darkMode ? "darkPopup" : "whitePopup",
              },
              didOpen: () => {
                const popup = Swal.getPopup();
                popup.style.marginLeft = "200px";
              },
            });
            if (typeof onSendResult === "function") {
              onSendResult({
                success: false,
                message: "Please complete all Retention Limit Amounts",
              });
            }
            return;
          }
          values.retentionList = retentionItemValues;
        }
        mandateFlag =
          validateField(values.invoiceNumber, setInvoiceNoErr) || mandateFlag;
      } else if (isThroughQuotation) {
        values.throughQuotation = true;
        values.documentsList = quoDocuments.filter(
          (document) => !document.file
        );
      }

      const filterItemList = pricing.items.filter((item) =>
        Boolean(
          item.itemID || item.itemName?.trim() || item.itemDescription?.trim()
        )
      );
      if (!filterItemList.length) {
        if (
          redirectToOutside === "redirectToItemWhenSave" &&
          !isThroughQuotation
        ) {
          if (InvoiceID) {
            navigate(`/items/addItems?new=invoice&id=${InvoiceID}`);
          } else {
            sessionStorage.setItem("HoldQuotationData", JSON.stringify(values));
            navigate("/items/addItems?new=invoice");
          }
          return;
        }
        const message = "Enter an item name or description.";
        if (typeof onSendResult === "function") {
          onSendResult({ success: false, message });
        }
        showResMsg(message, 2000, false);
        return;
      }

      const allRowsFilled = filterItemList.every(
        (row) =>
          Boolean(
            String(row.itemName || "").trim() ||
              String(row.itemDescription || "").trim()
          ) &&
          row.itemPrice !== undefined &&
          row.itemPrice !== "" &&
          row.itemQuantity !== undefined &&
          row.itemQuantity !== "" &&
          (row.discountType === "None" ||
            (row.discountValue !== undefined && row.discountValue !== ""))
      );
      if (!allRowsFilled) {
        const message = identifyMissingItems(filterItemList);
        if (typeof onSendResult === "function") {
          onSendResult({ success: false, message });
        }
        showResMsg(message, 2000, false);
        return;
      }
      values.itemsList = filterItemList;

      if (
        !InvoiceID &&
        !isThroughQuotation &&
        redirectToOutside === "redirectToEditItemWhenSave"
      ) {
        sessionStorage.setItem("HoldQuotationData", JSON.stringify(values));
        const itemId = sessionStorage.getItem("ItemIdForItemEdit");
        navigate(`/items/editItem/itemid=${itemId}?new=invoice`);
        return;
      }

      if (mandateFlag) {
        if (typeof onSendResult === "function") {
          onSendResult({
            success: false,
            message: "Please fill in all required fields.",
          });
        }
        return;
      }

      const { lists, ...currentValues } = values;
      const invoicePayload = {
        ...currentValues,
        invoiceNumber: String(currentValues.invoiceNumber || "").trim(),
        type: type || currentValues.type,
        invoiceID: InvoiceID || currentValues.invoiceID,
        currencyValue: currencyCode,
        itemsList: values.itemsList,
        totalAmount: pricing.totalAmount.toFixed(2),
        totalDiscountAmount: pricing.totalDiscountAmount.toFixed(2),
        totalGSTAmount: pricing.totalGSTAmount.toFixed(2),
        finalAmount: pricing.finalAmount.toFixed(2),
        scheduleRetention: Boolean(InvoiceID)
          ? scheduleRetention
          : currentValues.scheduleRetention,
        retentionList:
          InvoiceID && scheduleRetention
            ? retentionItemValues
            : currentValues.retentionList,
        throughQuotation: isThroughQuotation,
        documentsList: isThroughQuotation
          ? quoDocuments.filter((document) => !document.file)
          : currentValues.documentsList,
      };
      console.log("valuessss-handleApiResponse", invoicePayload);

      return await handleApiResponse({
        isUpdate: Boolean(InvoiceID || invoicePayload.invoiceID),
        values: invoicePayload,
        setOpen,
        showResMsg,
        navigate,
        handleSoftDismisal,
        setShowBillingModal,
        dispatch,
        redirectToOutside,
        InvoiceID,
        setValues,
        setIsPreviewMode,
        onSendResult,
        saveAttachments,
        onSaved: () => {
          numberValidation.clearError();
          draftDocument.markSaved(invoicePayload, itemRowValues);
          unsavedChanges.markSaved();
          afterSaved?.();
        },
        onNumberError: (data) => {
          if (!numberValidation.handleResponse(data)) return false;
          setOpen(false);
          return true;
        },
      });
    } finally {
      draftSaveRef.current = false;
      setIsSavingDraft(false);
    }
  };
  saveAndExitRef.current = async () => {
    let saved = false;
    await handleSaveInvoice("saveAndExit", null, () => {
      saved = true;
    });
    return saved;
  };
  const handleSoftDismisal = () => {
    ShowSwalWithButtons(
      `The Reference number already exists`,
      "Do you wish to continue?",
      "warning",
      darkMode,
      () => {
        values.skip_PO_NO = true;
        handleSaveInvoice();
      }
    );
  };

  const resetNewItemForm = (itemName = "") => {
    setNewItemForm({ ...EMPTY_CATALOGUE_ITEM, itemName });
  };

  const handleAddNewItem = () => {
    setActiveItemDropdownIdx(null);
    const emptyRowIndex = itemRowValues.findIndex((row) => !row.itemID);
    setItemModalTargetIdx(emptyRowIndex === -1 ? null : emptyRowIndex);
    setItemModalError("");
    resetNewItemForm();
    setIsItemModalOpen(true);
  };
  //Handles Item Rows Functions
  const handleRemove = (index) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to remove the Item?`,
      "warning",
      darkMode,
      () => {
        const itemError = draftValidationField?.match(
          /^(invoice-item(?:-search|Price|Quantity)-)(\d+)$/
        );
        if (itemError && Number(itemError[2]) >= index) {
          const errorIndex = Number(itemError[2]);
          setDraftValidationField(
            errorIndex === index ? null : `${itemError[1]}${errorIndex - 1}`
          );
          setDraftSaveError("");
        }
        setItemRowValues((currentRows) =>
          currentRows.length <= 1
            ? [{ ...EMPTY_ITEM_ROW }]
            : currentRows.filter((_, rowIndex) => rowIndex !== index)
        );
        setItemSearchQueries({});
        setActiveItemDropdownIdx(null);
      }
    );
  };
  const handleEdit = (id, index) => {
    sessionStorage.setItem("ItemIdForItemEdit", id);
    ShowSwalWithButtons(
      "Are you sure?",
      "Would you like to Edit the Item?",
      "warning",
      darkMode,
      async () => {
        await handleSaveInvoice("redirectToEditItemWhenSave");
      }
    );
  };

  const handleCancel = (index) => {
    const paramValue = new URLSearchParams(window.location.search).get(
      "status"
    );
    navigate(paramValue === "debt" ? "/debts" : "/invoices");
  };

  const handleAddLineRow = () => {
    setHasEditedInvoice(true);
    setActiveItemDropdownIdx(null);
    pendingItemsScrollRef.current = "bottom";
    setItemRowValues((prev) => [
      ...(prev.length ? prev : [{ ...EMPTY_ITEM_ROW }]),
      { ...EMPTY_ITEM_ROW },
    ]);
  };

  const calculateDiscountAmount = (newItemRowValues) => {
    console.log("calculateDiscountAmount called", newItemRowValues);
    const updatedRows = newItemRowValues.map((item, idx) => {
      const itemPrice = parseFloat(item.itemPrice);
      const itemQuantity = parseFloat(item.itemQuantity);
      const discountValue = parseFloat(item.discountValue);
      let discountAmount = 0;
      const totalAmount = itemPrice * itemQuantity;
      if (item.discountType === "Percentage") {
        discountAmount = (totalAmount * discountValue) / 100;
      } else {
        discountAmount = discountValue;
      }
      return {
        ...item,
        discountAmount: parseFloat(discountAmount.toFixed(2)) || 0,
      };
    });
    setItemRowValues(updatedRows);
    handleCalculation(values.gstType);
  };

  const handleCalculation = (gstType, rows = itemRowValues) => {
    const pricing = calculateInvoiceTotals(rows, gstType || "Inclusive");
    const rowsNeedUpdate = pricing.items.some(
      (item, index) =>
        Number(item.discountAmount) !==
          Number(rows[index]?.discountAmount || 0) ||
        Number(item.totalItemPrice) !==
          Number(rows[index]?.totalItemPrice || 0) ||
        Number(item.gstAmount) !== Number(rows[index]?.gstAmount || 0) ||
        Number(item.subtotalExcludingGst) !==
          Number(rows[index]?.subtotalExcludingGst || 0)
    );

    if (rowsNeedUpdate) setItemRowValues(pricing.items);

    setValues((prevValues) => ({
      ...prevValues,
      gstType: gstType || "Inclusive",
      totalAmount: pricing.totalAmount.toFixed(2),
      totalDiscountAmount: pricing.totalDiscountAmount.toFixed(2),
      totalGSTAmount: pricing.totalGSTAmount.toFixed(2),
      finalAmount: pricing.finalAmount.toFixed(2),
    }));

    return pricing;
  };

  const handleItemRowChange = async (name, value, index) => {
    setHasEditedInvoice(true);
    console.log("TTT", name, value, index);
    const updatedRows = [...itemRowValues];
    if (name === "itemQuantity") {
      value = sanitizeQuantityInputValue(value);
    }
    if (name === "itemName") {
      updatedRows[index] = {
        ...updatedRows[index],
        itemName: value,
        itemID:
          value === updatedRows[index]?.itemName
            ? updatedRows[index]?.itemID
            : "",
      };
      setItemRowValues(updatedRows);
      return;
    }
    if (name === "categoryCodeName") {
      updatedRows[index] = {
        ...updatedRows[index],
        categoryCodeName: value,
      };
      setItemRowValues(updatedRows);
      return;
    }
    // if (name === 'itemPrice' || name === 'itemQuantity') {
    if (value === ".") {
      value = "0.";
    }

    const regex = /^\d{1,7}(?:\.\d{0,2})?$/;

    if (regex.test(value) || value === "") {
      if (name === "itemPrice" || name === "itemQuantity") {
        updatedRows[index] = { ...updatedRows[index], [name]: value };
        setItemRowValues(updatedRows);
      } else if (name === "discountValue") {
        console.log("discountValue called");
        if (
          itemRowValues[index].discountType === "Percentage" ||
          itemRowValues[index].discountType === "Fixed"
        ) {
          if (
            value === "" ||
            (parseFloat(value) < 100 &&
              itemRowValues[index].discountType === "Percentage")
          ) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }

          if (
            value === "" ||
            (parseFloat(value) <
              parseFloat(itemRowValues[index].itemPrice) *
                parseFloat(itemRowValues[index].itemQuantity) &&
              itemRowValues[index].discountType === "Fixed")
          ) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }
        }
      }
    } else if (name === "discountValue") {
      if (
        itemRowValues[index].discountType === "Percentage" ||
        itemRowValues[index].discountType === "Fixed"
      ) {
        if (
          value === "" ||
          (parseFloat(value) < 100 &&
            itemRowValues[index].discountType === "Percentage")
        ) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }

        if (
          value === "" ||
          (parseFloat(value) < parseFloat(itemRowValues[index].itemPrice) &&
            itemRowValues[index].discountType === "Fixed")
        ) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }
      }
    } else if (name === "discountType" && value === "None") {
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
        discountValue: 0,
        discountAmount: 0,
      };
      setItemRowValues(updatedRows);
    } else if (name === "discountType" && value === "Fixed") {
      updatedRows[index] = { ...updatedRows[index], [name]: value };
      setItemRowValues(updatedRows);
    } else {
      updatedRows[index] = { ...updatedRows[index], [name]: value };
      setItemRowValues(updatedRows);
    }
  };

  const handleItemDescription = async (name, value, index) => {
    const updatedRows = [...itemRowValues];
    updatedRows[index] = { ...updatedRows[index], [name]: value };
    setItemRowValues(updatedRows);
  };

  const handleItemRow = async (name, newValue, index) => {
    console.log("dataaas", index, name, newValue);
    if (!newValue) {
      showResMsg("Please select an item", 1000, false);
    }
    if (newValue.value === "add-new") {
      handleAddNewItem();
    } else {
      const selectedItem = masterItemDetails.find(
        (item) => item._id === newValue.value
      );
      if (selectedItem) {
        const updatedRows = [...itemRowValues];
        updatedRows[index] = {
          ...updatedRows[index],
          itemID: newValue.value,
          itemName: selectedItem.itemName,
          itemDescription: selectedItem.itemDescription
            ? selectedItem.itemDescription
            : selectedItem.itemName,
          categoryCodeName: selectedItem.categoryCodeName,
          itemPrice: parseFloat(selectedItem.itemPrice),
          itemQuantity: parseFloat(selectedItem.itemQuantity),
          totalItemPrice:
            parseFloat(selectedItem.itemPrice).toFixed(2) *
            parseFloat(selectedItem.itemQuantity).toFixed(2),
          gst: parseFloat(selectedItem.gst),
          discountType: selectedItem.discountType,
          discountValue: selectedItem.discountValue,
          discountAmount:
            selectedItem.discountType === "Fixed"
              ? selectedItem.discountValue
              : 0,
        };
        setItemRowValues(updatedRows);
      }
    }
  };

  const handleSelectCatalogueItem = (
    index,
    selectedItem,
    preserveLineQuantity = false
  ) => {
    setHasEditedInvoice(true);
    if (!selectedItem) return;

    const updatedRows = [...itemRowValues];
    const existingRow = updatedRows[index] || {};
    const preserveImportedValues = Boolean(existingRow.ocrImported);
    const itemPrice =
      preserveImportedValues && existingRow.itemPrice !== ""
        ? parseFloat(existingRow.itemPrice) || 0
        : parseFloat(selectedItem.itemPrice) || 0;
    const itemQuantity =
      (preserveImportedValues || preserveLineQuantity) &&
      existingRow.itemQuantity !== ""
        ? parseFloat(existingRow.itemQuantity) || 1
        : parseFloat(selectedItem.itemQuantity) || 1;
    const discountType = preserveImportedValues
      ? existingRow.discountType || "None"
      : selectedItem.discountType || "None";
    const sourceDiscountValue = preserveImportedValues
      ? existingRow.discountValue
      : selectedItem.discountValue;
    const discountValue =
      sourceDiscountValue !== undefined && sourceDiscountValue !== ""
        ? String(sourceDiscountValue)
        : discountType === "None"
        ? "0"
        : "";
    updatedRows[index] = {
      ...updatedRows[index],
      itemID: selectedItem._id,
      itemName: selectedItem.itemName,
      itemDescription: preserveImportedValues
        ? existingRow.itemDescription || ""
        : selectedItem.itemDescription || "",
      categoryCodeName: selectedItem.categoryCodeName || "Sales",
      itemPrice,
      itemQuantity,
      gst:
        preserveImportedValues && existingRow.gst !== ""
          ? parseFloat(existingRow.gst) || 0
          : selectedItem.gst !== undefined
          ? parseFloat(selectedItem.gst)
          : 10,
      discountType,
      discountValue,
      ocrImported: false,
    };

    setItemRowValues(updatedRows);
    setItemSearchQueries((prev) => ({ ...prev, [index]: undefined }));
    setActiveItemDropdownIdx(null);
  };

  const handleCatalogueItemUpdated = (savedItem) => {
    const result = Array.isArray(savedItem) ? savedItem[0] : savedItem;
    const current = editingCatalogueItem?.item;
    if (!current || !result) return;
    const updatedItem = {
      ...current,
      ...result,
      _id: result._id || current._id,
    };
    setMasterItemDetails((items) =>
      items.map((item) =>
        String(item._id) === String(updatedItem._id) ? updatedItem : item
      )
    );
    handleSelectCatalogueItem(
      editingCatalogueItem.rowIndex,
      updatedItem,
      true
    );
    setEditingCatalogueItem(null);
    showResMsg("Item updated successfully", 1500, true);
  };

  const getMatchingCatalogueItems = (query = "") => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return masterItemDetails;
    return masterItemDetails.filter(
      (item) =>
        item.itemName?.toLowerCase().includes(normalizedQuery) ||
        item.itemCode?.toLowerCase().includes(normalizedQuery) ||
        item.itemDescription?.toLowerCase().includes(normalizedQuery)
    );
  };

  const handleQuickCreateItem = async () => {
    if (isItemSaving) return;
    if (!newItemForm.itemCode.trim()) {
      setItemModalError("itemCode");
      return;
    }
    if (!newItemForm.itemName.trim()) {
      setItemModalError("itemName");
      return;
    }
    if (newItemForm.itemPrice === "") {
      setItemModalError("itemPrice");
      return;
    }

    setItemModalError("");
    setIsItemSaving(true);

    const payload = {
      businessUserID: loginDetails?.businessUserID,
      itemName: newItemForm.itemName.trim(),
      itemCode: newItemForm.itemCode.trim(),
      itemDescription: newItemForm.itemDescription.trim(),
      itemPrice: parseFloat(newItemForm.itemPrice) || 0,
      itemQuantity: parseFloat(newItemForm.defaultQuantity) || 1,
      categoryCodeName: newItemForm.categoryCodeName || "Sales",
      categoryName: newItemForm.categoryCodeName || "Sales",
      gst: newItemForm.gst !== undefined ? parseFloat(newItemForm.gst) : 10,
      itemStatus: newItemForm.status || "Active",
      unit: newItemForm.unit || "each",
      discountType: newItemForm.discountType || "None",
      discountValue: parseFloat(newItemForm.discountValue) || 0,
      source: "invoice",
    };

    await addCatalogueItemData(
      payload,
      (data) => {
        if (data?.Result_Status && data.Result_Output) {
          showDraftSavedMessage("Catalogue item created successfully");
          const created = data.Result_Output;
          setMasterItemDetails((prev) => [created, ...prev]);

          if (itemModalTargetIdx !== null) {
            handleSelectCatalogueItem(itemModalTargetIdx, created);
          } else {
            const createdRow = {
              ...EMPTY_ITEM_ROW,
              itemID: created._id,
              itemName: created.itemName,
              itemDescription: created.itemDescription || "",
              itemPrice: parseFloat(created.itemPrice || 0),
              itemQuantity:
                parseFloat(
                  created.itemQuantity || newItemForm.defaultQuantity
                ) || 1,
              totalItemPrice: (
                (parseFloat(created.itemPrice) || 0) *
                (parseFloat(
                  created.itemQuantity || newItemForm.defaultQuantity
                ) || 1)
              ).toFixed(2),
              gst: created.gst !== undefined ? parseFloat(created.gst) : 10,
              categoryCodeName: created.categoryCodeName || "Sales",
              discountType: created.discountType || "None",
              discountValue: created.discountValue || "",
            };

            setItemRowValues((prev) => {
              const firstEmptyIndex = prev.findIndex(
                (row) =>
                  !row.itemID &&
                  !String(row.itemName || "").trim() &&
                  !String(row.itemDescription || "").trim()
              );
              if (firstEmptyIndex === -1) return [...prev, createdRow];
              const updated = [...prev];
              updated[firstEmptyIndex] = createdRow;
              return updated;
            });
            setItemSearchQueries({});
          }

          setItemModalTargetIdx(null);
          setIsItemModalOpen(false);
          resetNewItemForm();
        } else {
          const message =
            data?.Result_Message || "Failed to create catalogue item.";
          setItemModalError(message);
          showResMsg(message, 2000, false);
        }
      },
      dispatch,
      { showLoader: false }
    );
    setIsItemSaving(false);
  };

  const filteredOptions = itemsDetails.map((item) => ({
    label: item.itemName,
    value: item._id,
  }));

  let columns = [
    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Autocomplete
          disableClearable
          key={`${i}-${row.itemID}`}
          id={`item-${i}`}
          sx={{
            "& .MuiInputBase-root": {
              width: "170px",
            },
          }}
          options={[
            { label: "Add New Item", value: "add-new" },
            ...filteredOptions,
          ]}
          onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
          value={row.itemName}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              variant="standard"
              placeholder="Search for an Item"
              size="medium"
              // sx={{ color: darkMode ? "white" : "black", }}
              sx={{
                "& .MuiInput-root": {
                  height: "35.11px",
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              inputProps={{
                ...params.inputProps,
                maxLength: 200, // ⭐ Max length applied
              }}
            />
          )}
          renderOption={(props, option) => {
            // const customStyle = option.value === 'add-new' ? 'dropDownDefaultHighlight' : darkMode ? 'autoCompleteDarkList' : 'autoCompleteList';
            const customStyle =
              option.value === "add-new"
                ? darkMode
                  ? tableBorder
                  : tableBorder
                : darkMode
                ? "autoCompleteDarkList"
                : "autoCompleteList";

            return (
              <li
                {...props}
                key={option.value}
                style={{
                  fontSize: "12px",
                  color: darkMode ? tableBorder : tableBorder,
                  padding: "4.8px 16px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                  cursor: "pointer",
                }}
                className={customStyle}
              >
                {option.label}
              </li>
            );
          }}
          filterOptions={(options, state) => {
            const filtered = options.filter((option) =>
              option.label
                .toLowerCase()
                .includes(state.inputValue.toLowerCase())
            );
            if (!filtered.some((option) => option.value === "add-new")) {
              filtered.unshift({ label: "Add New Item", value: "add-new" });
            }
            return filtered;
          }}
        />
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "170px",
      marginTop: "4px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) =>
                handleItemDescription("itemDescription", event.target.value, i)
              }
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              variant="standard"
              sx={{
                "& .MuiInputBase-root": {
                  width: "320px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: "12px",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                  width: "100%",
                  minWidth: "300px",
                  color: darkMode ? "white" : "black",
                  boxSizing: "border-box",
                  display: "block",
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "260px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              className="removeExtraPadding "
              fullWidth
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) =>
                handleItemRowChange("itemQuantity", event.target.value, i)
              }
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 4,
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatNumberWithCommas(row.itemPrice)}
              variant="standard"
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              onChange={(event) =>
                handleItemRowChange("itemPrice", event.target.value, i)
              }
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                // pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatCurrencyAUD(row.totalItemPrice)}
              variant="standard"
              onChange={(event) =>
                handleItemRowChange("totalItemPrice", event.target.value, i)
              }
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              disabled
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) =>
                handleItemRowChange("categoryCodeName", event.target.value, i)
              }
              fullWidth
              className="dayHour"
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "200px",
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              value={row.gst}
              onChange={(event) =>
                handleItemRowChange("gst", event.target.value, i)
              }
              disabled
              style={{ cursor: "default", pointerEvents: "none" }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Discount Type</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              variant="standard"
              sx={{ m: 1, mt: 0, ml: -1.5 }}
            >
              <Select
                style={{ height: "35.11px", marginTop: "1.5px" }}
                labelId="day-hours-select-label"
                id="day-hours-select"
                className="dayHour"
                value={row.discountType}
                onChange={(event) =>
                  handleItemRowChange("discountType", event.target.value, i)
                }
                fullWidth
                sx={{
                  width: "100px",
                  color: darkMode ? "white" : "black",
                  "& .MuiInputBase-root ": {},
                  "&:before": {
                    borderBottomColor: darkMode ? "white" : tableBorder,
                  },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottomColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderBottomColor: darkMode ? tableBorder : tableBorder,
                  },
                  "& .MuiSelect-select": {
                    color: darkMode ? "white" : "black",
                  },
                }}
                variant="standard"
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Percentage">Percentage</MenuItem>
                <MenuItem value="Fixed">Fixed amount</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "140px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Discount Value</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              sx={{
                color: darkMode ? "white" : "black",
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              disabled={row.discountType === "None"}
              value={row.discountType === "None" ? 0 : row.discountValue ?? ""}
              // value={row.discountType === "None" ? 0 : row.discountValue}
              onChange={(event) =>
                handleItemRowChange("discountValue", event.target.value, i)
              }
              inputProps={{
                maxLength: 30,
                pattern: "^[a-zA-Z0-9 ]+$",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      // name: "Action",
      name: <p></p>,
      selector: (row) => row._id,
      cell: (row, i) => (
        <>
          <Grid
            container
            style={{ display: "flex", justifyContent: "center" }}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              {row.itemID &&
              itemRowValues.length > 1 &&
              (InvoiceID === undefined || itemRowValues.length > 2) ? (
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    handleRemove(i, row.itemID);
                  }}
                  title="Delete"
                />
              ) : (
                <TimelineItem color="gray" icon="delete" title="Delete" />
              )}
              {/* {row.itemID ?

                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    handleRemove(i);
                  }}
                  title="Delete"
                />
                :
                <TimelineItem
                  color="gray"
                  icon="delete"
                  title="Delete"
                />


              } */}
            </Grid>
            <Grid item>
              {row.itemID ? (
                <TimelineItem
                  color="success"
                  icon="edit"
                  onClick={() => {
                    handleEdit(row.itemID, i);
                  }}
                  title="Edit"
                />
              ) : (
                <TimelineItem color="gray" icon="edit" title="Edit" />
              )}
            </Grid>
          </Grid>
        </>
      ),
    },
  ];
  let quotationReadOnlyColumns = [
    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Autocomplete
          disableClearable
          key={`${i}-${row.itemID}`}
          id={`item-${i}`}
          sx={{
            "& .MuiInputBase-root": {
              width: "170px",
            },
          }}
          options={[
            { label: "Add New Item", value: "add-new" },
            ...filteredOptions,
          ]}
          onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
          value={row.itemName}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              disabled
              variant="standard"
              placeholder="Search for an Item"
              size="medium"
              // sx={{ color: darkMode ? "white" : "black", }}
              sx={{
                "& .MuiInput-root": {
                  height: "35.11px",
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
            />
          )}
          renderOption={(props, option) => {
            // const customStyle = option.value === 'add-new' ? 'dropDownDefaultHighlight' : darkMode ? 'autoCompleteDarkList' : 'autoCompleteList';
            const customStyle =
              option.value === "add-new"
                ? darkMode
                  ? tableBorder
                  : tableBorder
                : darkMode
                ? "autoCompleteDarkList"
                : "autoCompleteList";
            return (
              <li
                {...props}
                key={option.value}
                style={{
                  fontSize: "12px",
                  color: darkMode ? tableBorder : tableBorder,
                  padding: "4.8px 16px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                  cursor: "pointer",
                }}
                disabled={typeQuotation && !InvoiceID}
                className={customStyle}
              >
                {option.label}
              </li>
            );
          }}
          filterOptions={(options, state) => {
            const filtered = options.filter((option) =>
              option.label
                .toLowerCase()
                .includes(state.inputValue.toLowerCase())
            );

            if (!filtered.some((option) => option.value === "add-new")) {
              filtered.unshift({ label: "Add New Item", value: "add-new" });
            }
            return filtered;
          }}
        />
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "170px",
      marginTop: "4px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) =>
                handleItemDescription("itemDescription", event.target.value, i)
              }
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              disabled
              variant="standard"
              sx={{
                "& .MuiInputBase-root": {
                  width: "320px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: "12px",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                  width: "100%",
                  minWidth: "300px",
                  color: darkMode ? "white" : "black",
                  boxSizing: "border-box",
                  display: "block",
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "360px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              className="removeExtraPadding "
              fullWidth
              disabled
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) =>
                handleItemRowChange("itemQuantity", event.target.value, i)
              }
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={row.itemPrice}
              variant="standard"
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              onChange={(event) =>
                handleItemRowChange("itemPrice", event.target.value, i)
              }
              fullWidth
              disabled
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 10,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={row.totalItemPrice}
              variant="standard"
              disabled
              onChange={(event) =>
                handleItemRowChange("totalItemPrice", event.target.value, i)
              }
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) =>
                handleItemRowChange("categoryCodeName", event.target.value, i)
              }
              fullWidth
              className="dayHour"
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "200px",
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              disabled
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              value={row.gst}
              onChange={(event) =>
                handleItemRowChange("gst", event.target.value, i)
              }
              style={{ cursor: "default", pointerEvents: "none" }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },
  ];
  const updateUploadedDocuments = (uploaded, pendingID) => {
    setDocuments((previous) => [
      ...uploaded,
      ...previous.filter(
        (document) => document.file && document._id !== pendingID
      ),
    ]);
  };

  const saveAttachments = async (invoiceID) => {
    if (!quoDocuments.some((document) => document.file)) return true;
    setLoading(true);
    try {
      await uploadPendingAttachments(
        "invoice",
        invoiceID,
        quoDocuments,
        updateUploadedDocuments
      );
      setFileError("");
      return true;
    } catch (error) {
      const message = `Draft saved, but ${error.message} Save again to retry the attachment.`;
      setFileError(message);
      showResMsg(message, 2000, false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  //Quotation Document Functions
  const saveFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (file.size > 1 * 1024 * 1024) {
      setFileError("File size should be less than 1 MB");
      return;
    }
    setFileError("");
    const document = {
      ...createPendingAttachment(file),
      documentID: values.selectedID,
    };
    setDocuments((previous) => [...previous, document]);
    const invoiceID = InvoiceID || values.invoiceID;
    if (!invoiceID) return;
    setLoading(true);
    try {
      await uploadPendingAttachments(
        "invoice",
        invoiceID,
        [document],
        updateUploadedDocuments
      );
      setValues((previous) => ({
        ...previous,
        documentName: "",
        selectedID: "",
      }));
      showResMsg("Document uploaded successfully", 1500, true);
    } catch (error) {
      setFileError(`${error.message} Save the draft to retry.`);
    } finally {
      setLoading(false);
    }
  };

  const handleEditDocument = (selectedDocRow) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to edit "${selectedDocRow.documentName}" file?`,
      "warning",
      darkMode,
      () => {
        setValues({
          ...values,
          documentName: selectedDocRow.documentName,
          selectedID: selectedDocRow._id,
        });
      }
    );
  };

  const handleDeleteDocument = async (selectedDocRow) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to delete "${selectedDocRow.documentName}" file?`,
      "warning",
      darkMode,
      () => {
        if (selectedDocRow.file) {
          setDocuments((previous) =>
            previous.filter((document) => document._id !== selectedDocRow._id)
          );
          setFileError("");
          return;
        }
        axios
          .post(
            appConstants.baseURL + "invoice/deleteInvoiceDocument",
            { documentID: selectedDocRow._id },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
              },
            }
          )
          .then((res) => {
            if (res.data.Result_Status) {
              showResMsg(
                genericMessage.documentDeleted,
                1000,
                res.data.Result_Status
              );

              const updatedQuoDocument = quoDocuments.filter((item) => {
                return item._id !== selectedDocRow._id;
              });
              setDocuments(updatedQuoDocument);
            } else {
              showResMsg(res.data.Result_Message, 2000, false);
            }
          })
          .catch((error) => {
            console.log("deleteQuotationDocument error", error.message);
          });
      }
    );
  };

  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action(s)",
      selector: (row) => row,
      center: "true",
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              {row.fileType === "docx" ||
              row.fileType === "doc" ||
              row.fileType === "excel" ? (
                <a
                  className="testing"
                  href={
                    appConstants.baseURL +
                    "quotation/viewUploadedQuotationDocument?fileName=/" +
                    row.documentFileName
                  }
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TimelineItem
                    color="info"
                    icon="visibility"
                    onClick={() => {
                      renderFilePreview(row);
                    }}
                    title="View"
                    // disabled={SCREEN_RIGHT === "View Only"}
                  />
                </a>
              ) : (
                <TimelineItem
                  color="info"
                  icon="visibility"
                  onClick={() => {
                    handleViewDocument(row);
                  }}
                  title="View"
                  // disabled={SCREEN_RIGHT === "View Only"}
                />
              )}
            </Grid>
            {InvoiceID && (
              <Grid item>
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => handleDeleteDocument(row)}
                  title="Delete"
                  disabled={SCREEN_RIGHT === "View Only"}
                />
              </Grid>
            )}
          </Grid>
        </>
      ),
    },
  ];

  const handleDateChange = async (date) => {
    setHasEditedInvoice(true);
    values.invoiceDate = await formatDateWithCurrentTimeForPickDate(date);
    setValues({ ...values, invoiceDate: values.invoiceDate });
  };

  const handleDueDateChange = async (date) => {
    setHasEditedInvoice(true);
    values.dueDate = await formatDateWithCurrentTimeForPickDate(date);
    setValues({ ...values, dueDate: values.dueDate });
  };

  const addNewRetentionRow = () => {
    const allRowsFilled = retentionItemValues.every(
      (row) => row.retentionPaymentAmount && row.retentionDueDate
    );
    if (allRowsFilled) {
      if (parseFloat(usedRetentionAmount) < parseFloat(values.finalAmount)) {
        const InvoiceDueDate = new Date(values.dueDate).toLocaleDateString();
        retentionItemValues.some((element, index) => {
          const retentionDueDate = new Date(
            element.retentionDueDate
          ).toLocaleDateString();
          if (retentionDueDate > InvoiceDueDate) {
            setLoading(true);
            setTimeout(async () => {
              showResMsg(
                `Retention Due Date on ${values.invoiceNumber}/R${
                  index + 1
                } can't be more than Invoice Due Date`,
                2000,
                false
              );
              setLoading(false);
            }, 2000);

            return true;
          }
          return false;
        });

        setRetentionItemValues([
          ...retentionItemValues,
          {
            retentionPaymentAmount: "",
            retentionNumber: `${values.invoiceNumber}/R${
              retentionItemValues.length + 1
            }`,
            retentionDueDate: new Date(
              new Date() - new Date().getTimezoneOffset() * 60000
            ),
          },
        ]);
      } else {
        setLoading(true);
        setTimeout(async () => {
          showResMsg(
            `Unable to add row for Retention as Retention limit has been reached.`,
            2000,
            false
          );
          setLoading(false);
        }, 2000);
      }
    } else {
      showResMsg(
        "Please fill in all Fields values before adding a new row for retention.",
        2000,
        false
      );
    }
  };

  const handleRemoveRetention = (index) => {
    if (retentionItemValues.length >= 1) {
      ShowSwalWithButtons(
        "Are you sure?",
        `Would you like to remove this Retention?`,
        "warning",
        darkMode,
        () => {
          const list = [...retentionItemValues];
          list.splice(index, 1);
          list.forEach((element) => {
            element.retentionNumber = `${values.invoiceNumber}/R${
              list.indexOf(element) + 1
            }`;
          });
          setRetentionItemValues(list);
          if (list.length === 0) {
            setScheduleRetention(false);
          }
        }
      );
    }
  };
  const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
  };
  let columnRetention = [
    {
      name: "Retention No.",
      selector: (row, i) => (
        <TextField
          type="text"
          value={row.retentionNumber}
          variant="outlined"
          fullWidth
          disabled
        />
      ),
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
        display: "block",
      },
    },
    {
      name: `Payment Amount (${currencyCode})`,
      selector: (row, i) => (
        <TextField
          type="text"
          value={row.retentionPaymentAmount}
          variant="outlined"
          onChange={(event) =>
            handleRetentionRowChange(
              "retentionPaymentAmount",
              event.target.value,
              i
            )
          }
          autoFocus
          fullWidth
          disabled={row.retentionStatus === "Paid"}
          autoComplete="off"
          inputProps={{
            maxLength: 12,
            // pattern: "[]",
          }}
        />
      ),
      center: "true",
      style: {
        paddingLeft: "20px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },

    {
      name: "Retention Due Date",
      selector: (row, i) => (
        <PickDate
          size="sm"
          disabled={row.retentionStatus === "Paid"}
          selected={
            isValidDate(new Date(row.retentionDueDate))
              ? new Date(row.retentionDueDate)
              : new Date()
          }
          onChange={(date) =>
            handleRetentionRowChange("retentionDueDate", date, i)
          }
          dateFormat="MMM d, yyyy"
          minDate={new Date(values.invoiceDate)}
          maxDate={new Date(values.dueDate)}
        />
      ),
      center: "true",
      style: {
        paddingLeft: "20px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },

    {
      name: "Action(s)",
      selector: (row) => row._id,
      center: "true",
      cell: (row, i) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              {row.retentionStatus !== "Paid" ? (
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    handleRemoveRetention(i);
                  }}
                  title="Delete Retention"
                />
              ) : (
                <TimelineItem color="grey" icon="delete" />
              )}
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  const handleRetentionRowChange = async (name, value, index) => {
    const updatedRows = [...retentionItemValues];
    if (name === "retentionPaymentAmount") {
      if (value === ".") {
        value = "0.";
      }
      const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
      if (regex.test(value) || value === "") {
        if (parseFloat(value) === 0 || value === "") {
          showResMsg(
            "Retention " + (await convertToTitleCase(name)) + " can't be zero",
            2000,
            false
          );
        }
        updatedRows[index] = { ...updatedRows[index], [name]: value };
        const sum = updatedRows.reduce(
          (acc, curr) =>
            parseFloat(acc) + parseFloat(curr.retentionPaymentAmount || 0),
          0
        );

        if (parseFloat(sum) > parseFloat(values.finalAmount)) {
          setLoading(true);
          setTimeout(async () => {
            showResMsg(
              `Sum of Retention ${await convertToTitleCase(
                name
              )} can't be more than Retention Limit Amount`,
              2000,
              false
            );
            setLoading(false);
          }, 2000);
          return;
        } else {
          setRetentionItemValues(updatedRows);
        }
      }
    } else if (name === "retentionDueDate") {
      updatedRows[index] = { ...updatedRows[index], [name]: new Date(value) };
      setRetentionItemValues(updatedRows);
    }
  };

  const handleSaveAndSendToEmail = async () => {
    if (itemRowValues.every((row) => !row.itemID)) {
      showResMsg(genericMessage.noItemBeforeEmail, 2000, false);
    } else {
      ShowSwalWithButtons(
        "Are you sure?",
        `Would you like to send the Invoice ${values.invoiceNumber} via email to the Customer Email Address?`,
        "question",
        darkMode,
        () => {
          values.sendEmailFlag = true;
          handleSaveInvoice();
        }
      );
    }
  };

  const handleRedirectToPaymentScreen = () => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to redirect the Invoice ${values.invoiceNumber} payment details?`,
      "warning",
      darkMode,
      () => {
        navigate("/invoices/payment/" + InvoiceID);
      }
    );
  };

  const handleRetentionClick = () => {
    console.log("featureAccess", featureAccess);
    if (featureAccess) {
      setScheduleRetention(true);
      setRetentionItemValues([
        ...retentionItemValues,
        {
          retentionNumber: `${values.invoiceNumber}/R1`,
          retentionPaymentAmount: "",
          retentionDueDate: new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000
          ),
        },
      ]);
    } else {
      showResMsg(`${genericMessage.notAllowed}`, 2000, false);
    }
  };

  const handleViewDocument = (selectedDocRow) => {
    setSelectedFileType(selectedDocRow.fileType);
    if (
      selectedDocRow.fileType === "pdf" ||
      selectedDocRow.fileType === "image"
    ) {
      const path =
        appConstants.baseURL +
        "quotation/viewUploadedQuotationDocument?fileName=/" +
        selectedDocRow.documentFileName;
      setSetDocumentFileURL(path);
      path && setViewDocumentInModal(true);
    } else {
      showResMsg("Document type not supported.", 2000, false);
    }
  };
  const renderFilePreview = (selectedDocRow) => {
    setSetDocumentFileURL(
      appConstants.baseURL +
        "quotation/viewUploadedQuotationDocument?fileName=/" +
        selectedDocRow.documentFileName
    );
  };
  const handleCloseViewModal = () => {
    setSetDocumentFileURL("");
    setSelectedFileType("");
    setViewDocumentInModal(false);
  };

  const handleEmailQuotation = async () => {
    if (isSavingDraft || isSendingInvoice) return;
    feedbackBus.emit({ scope: "global", message: "", duration: 0 });
    // Match the quotation editor: on an untouched invoice, show only the
    // customer validation first instead of surfacing every draft error at once.
    if (!values.contactID) {
      setContactNameErr(true);
      setIsCustomerDropdownOpen(true);
      document.getElementById("invoice-customer-input")?.focus();
      return;
    }
    if (!validateInvoiceDraft()) {
      return;
    }

    let targetId = InvoiceID || values.invoiceID;
    if (!draftDocument.canUseDocumentActions) {
      const saveResult = await handleSaveInvoice("prepareSend");
      if (!saveResult?.Result_Status) return;
      targetId = saveResult.Result_Output?._id || targetId;
    }

    const openSendModal = (emailData = {}) => {
      setTemplateValues({
        ...emailData,
        screenType: "Invoices",
        selectedID: targetId,
      });
      setOpen(true);
    };

    if (AllKeysHaveValue(templateValues)) {
      openSendModal(templateValues);
    } else {
      await getEmailAndTemplateForQuotation(
        {
          screenType: templateValues.screenType,
          contactID: values.contactID,
          selectedID: targetId,
          userID: sessionStorage.getItem("USER_ID").replaceAll('"', ""),
        },
        (data) => {
          if (data.Result_Status) {
            openSendModal(data.Result_Output);
          } else {
            showResMsg("Please try again! Something went wrong");
            setOpen(false);
          }
        },
        dispatch
      );
    }
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
  };

  const handleSend = async (templateData) => {
    setIsSendingInvoice(true);
    return new Promise((resolve) => {
      let payload = {
        userEmailAddress: templateData.userEmailAddress,
        customerEmailAddress: [...templateData.customerEmailAddress],
        emailTemplate: { ...templateData.emailTemplate },
        sendMeCopy: templateData.sendMeCopy,
        attachPdf: templateData.attachPdf,
        screenType: templateData.screenType || "Invoices",
      };
      // Persist the draft first, then let handleApiResponse call ResendEmail
      // exactly once. Setting this to true makes updateInvoice attempt to send
      // during the save and the success callback send the same email again.
      values.sendEmailFlag = false;
      values.templateValues = payload;
      handleSaveInvoice(null, (result) => {
        setIsSendingInvoice(false);
        if (result?.targetId) {
          setSavedTargetId(result.targetId);
        }
        if (result?.success && result?.targetId) {
          setValues((previous) => ({
            ...previous,
            invoiceID: result.targetId,
            invoiceNumber: result.assignedNo || previous.invoiceNumber,
            emailSent: (previous.emailSent || 0) + 1,
            activityStatus: "Sent",
          }));
          if (InvoiceID && !isInvoiceSent) {
            showDraftSavedMessage("Invoice sent successfully");
            setOpen(false);
            navigate(`/invoices/view/${result.targetId}`);
          }
        }
        resolve(result);
      });
    });
  };
  //Modal Email Template used fxn ends

  // Preview invoice
  const handlePreviewInvoice = () => {
    const targetId = InvoiceID || values.invoiceID;
    if (!draftDocument.canUseDocumentActions) {
      showResMsg("Save draft first.", 2000, false);
      return;
    }
    navigate(`/invoices/edit/${targetId}?mode=preview`, {
      replace: true,
      state: {
        ...location.state,
        previewReturn: {
          path: `${location.pathname}${location.search}`,
          label: "Back to Edit invoice",
        },
      },
    });
  };

  const handleDownloadInvoice = async () => {
    const targetId = InvoiceID || values.invoiceID;
    if (!draftDocument.canUseDocumentActions) {
      showResMsg("Save draft first.", 2000, false);
      return;
    }
    if (isDownloadingPdf) return;
    setIsDownloadingPdf(true);
    try {
      await downloadInvoice(
        { _id: targetId },
        (response) => {
          if (!response?.data)
            throw new Error("The invoice PDF could not be generated.");
          savePdfResponse(
            response,
            `invoice_${values.invoiceNumber || targetId}.pdf`
          );
          showResMsg("PDF downloaded successfully.", 1500, true);
        },
        dispatch
      );
    } finally {
      setIsDownloadingPdf(false);
    }
  };
  const customerOptions = [
    ...(showAddNewCustomer
      ? [{ label: "Add New Customer", value: "add-new" }]
      : []),
    ...contactDetails.map((contact) => ({
      label:
        contact.companyName ||
        `${contact.firstName || ""} ${contact.lastName || ""}`.trim() ||
        contact.name ||
        "Customer",
      value: contact._id,
      email:
        contact.emailAddress ||
        contact.customerEmailAddress ||
        contact.email ||
        "",
    })),
  ];

  const organisation =
    previewBusinessProfile?.companyName ||
    loginDetails?.companyName ||
    loginDetails?.businessName ||
    loginDetails?.organisationName ||
    loginDetails?.organizationName ||
    loginDetails?.fullName ||
    loginDetails?.name ||
    "My Organisation";
  const resolvedPreviewLogoFileName =
    previewLogoFileName || values.defaultLogoFileName || "";
  const previewBusinessLogo = resolvedPreviewLogoFileName
    ? `${appConstants.baseURL}employee/viewFile?fileName=${encodeURIComponent(
        resolvedPreviewLogoFileName
      )}`
    : "";
  const currentUser =
    `${loginDetails?.firstName || ""} ${loginDetails?.lastName || ""}`.trim() ||
    "User";
  const selectedCustomer = contactDetails.find(
    (contact) => String(contact._id) === String(values.contactID)
  );
  const previewCustomerName =
    selectedCustomer?.companyName ||
    `${selectedCustomer?.firstName || ""} ${
      selectedCustomer?.lastName || ""
    }`.trim() ||
    selectedCustomer?.name ||
    values.contactName ||
    values.customerName ||
    customerOptions.find((c) => String(c.value) === String(values.contactID))
      ?.label ||
    "Customer";
  const previewCustomerDetails = selectedCustomer || {
    emailAddress: values.recipientEmail || values.contactEmail || "",
  };
  const usableRows = itemRowValues.length ? itemRowValues : [EMPTY_ITEM_ROW];
  const canSendInvoice = Boolean(values.contactID && showSendEmailBtn);
  const hasValidItemForPreview = itemRowValues.some(
    (r) =>
      (r.itemID || r.itemName?.trim() || r.itemDescription?.trim()) &&
      r.itemPrice !== undefined &&
      r.itemPrice !== "" &&
      r.itemQuantity
  );
  const canPreview = draftDocument.canUseDocumentActions;
  const invoicePreviewReturn = resolvePreviewReturn(
    location,
    `/invoices/view/${InvoiceID || values.invoiceID}`,
    "Back to details"
  );
  const previewPaymentsReceived = (values.invoicePayment || []).reduce(
    (sum, payment) =>
      sum + Number(payment.paymentAmount ?? payment.amount ?? 0),
    0
  );
  const isPreviewDocumentReady =
    quotationLoaded ||
    Boolean(values.invoiceID && draftDocument.canUseDocumentActions);
  const showInvoiceSaveIndicator =
    isSavingDraft ||
    canPreview ||
    (draftDocument.hasUnsavedChanges &&
      (hasEditedInvoice ||
        values.contactID ||
        values.quotationID ||
        quoDocuments.length > 0 ||
        itemRowValues.some(
          (row) =>
            row.itemID || row.itemName?.trim() || row.itemDescription?.trim()
        )));
  const isInvoiceSent = Boolean(
    (InvoiceID || values.invoiceID) &&
      (Number(values.emailSent) > 0 ||
        /^(sent|viewed|issued)$/i.test(values.activityStatus || "") ||
        finalise)
  );
  const editOutstanding = Math.max(
    0,
    Number(values.payablePendingAmount ?? values.finalAmount ?? 0) || 0
  );
  const canRecordPayment =
    isInvoiceSent &&
    editOutstanding > 0 &&
    !/^(paid|void|voided)$/i.test(values.invoiceStatus || "");
  const sendInvoiceLabel = isInvoiceSent ? "Resend invoice" : "Send invoice";
  const previewStatus = isInvoiceSent
    ? values.invoiceStatus || "Issued"
    : "Draft · Preview only";

  const invoiceFlowRedesignEnabled = Boolean("invoice-flow-v2");
  if (invoiceFlowRedesignEnabled) {
    return (
      <div
        className={`invoice-flow-shell invoice-editor-shell${
          darkMode ? " dark" : ""
        }`}
        data-pdf-document-id={InvoiceID || values.invoiceID}
      >
        {unsavedChanges.dialog}
        <DashboardNavigation
          open={navOpen}
          onClose={() => setNavOpen(false)}
          activePath="/invoices"
          organisation={organisation}
          role={loginDetails?.roleName || "Owner"}
        />
        <div className="invoice-flow-main">
          <AppHeader
            onOpenNav={() => setNavOpen(true)}
            userName={currentUser}
          />
          {InvoiceID && initialPageLoading && !isPreviewMode ? (
            <main className="invoice-editor-page">
              <PageSkeleton
                type="editor"
                variant="document"
                label="Loading invoice editor…"
              />
            </main>
          ) : isPreviewMode &&
            (initialPageLoading || !isPreviewDocumentReady) ? (
            <DocumentPreviewSkeleton
              variant="invoice"
              label="Loading invoice preview"
            />
          ) : isPreviewMode ? (
            <CustomerInvoicePreview
              organisation={organisation}
              businessLogo={previewBusinessLogo}
              invoiceNumber={values.invoiceNumber}
              status={previewStatus}
              customerName={previewCustomerName}
              customerDetails={previewCustomerDetails}
              invoiceDate={values.invoiceDate}
              dueDate={values.dueDate}
              dueUpto={values.dueUpto}
              currency={currencyCode || "AUD"}
              gstType={values.gstType}
              items={itemRowValues}
              scopeNotes={values.scopeNotes}
              invoiceNotes={values.terms}
              paymentInstructions={values.paymentInstruction}
              bankAccountName={
                values.bankAccountName || previewBusinessProfile?.bankAccountName
              }
              bankBsbCode={
                values.bankBsbCode || previewBusinessProfile?.bankBsbCode
              }
              bankAccountNumber={
                values.bankAccountNumber ||
                previewBusinessProfile?.bankAccountNumber
              }
              subtotal={values.totalAmount}
              totalDiscounts={values.totalDiscountAmount}
              totalGST={values.totalGSTAmount}
              grandTotal={values.finalAmount}
              payablePendingAmount={values.payablePendingAmount}
              paymentsReceived={previewPaymentsReceived}
              onBack={() => {
                navigate(invoicePreviewReturn.path, { replace: true });
              }}
              backLabel={invoicePreviewReturn.label}
              onSend={handleEmailQuotation}
              onDownload={handleDownloadInvoice}
              canSend={canSendInvoice}
              isSaved={
                draftDocument.canUseDocumentActions && !previewIdentityLoading
              }
              isSaving={isSavingDraft}
              isSending={isSendingInvoice}
              isDownloading={isDownloadingPdf}
              darkMode={darkMode}
            />
          ) : (
            <main
              className="invoice-editor-page"
              onChangeCapture={() => setHasEditedInvoice(true)}
            >
              <div data-draft-save-confirmation />
              <button
                className="invoice-flow-back"
                type="button"
                onClick={() => navigate("/invoices")}
              >
                <LuArrowLeft />
                Back to Invoices
              </button>
              <header className="invoice-editor-header quotation-editor-header">
                <div className="quotation-editor-title-row">
                  <div className="quotation-editor-identity">
                    <h1>{InvoiceID ? "Edit invoice" : "New invoice"}</h1>
                    <div className="quotation-editor-meta-row">
                      <span className="quotation-meta-docno">
                        {values.invoiceNumber || "New invoice"}
                      </span>
                      <span className="quotation-draft-status-pill">Draft</span>
                      <span className="quotation-meta-notsent">
                        {values.emailSent > 0 ? "Sent" : "Not sent"}
                      </span>
                      {showInvoiceSaveIndicator && (
                        <div
                          className={`quotation-save-indicator${
                            draftDocument.hasUnsavedChanges ? " unsaved" : ""
                          }`}
                          role="status"
                          aria-live="polite"
                        >
                          {draftDocument.hasUnsavedChanges ? (
                            <i aria-hidden="true" />
                          ) : (
                            <LuCheck aria-hidden="true" />
                          )}
                          <span>
                            {isSavingDraft
                              ? "Saving..."
                              : draftDocument.hasUnsavedChanges
                              ? "Unsaved changes"
                              : "Saved"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="invoice-editor-actions quotation-header-actions">
                    {canRecordPayment && (
                      <button
                        type="button"
                        onClick={() => setPaymentDialogOpen(true)}
                      >
                        <LuFileText />
                        Record payment
                      </button>
                    )}
                    {canPreview && (
                      <button type="button" onClick={handlePreviewInvoice}>
                        <LuFileText />
                        Preview
                      </button>
                    )}
                    <button
                      type="button"
                      className={isSavingDraft ? "is-loading btn-loading" : ""}
                      disabled={isSavingDraft || isSendingInvoice}
                      onClick={() => handleSaveInvoice("draft")}
                    >
                      {isSavingDraft ? (
                        <span className="btn-spinner" />
                      ) : (
                        <LuSave />
                      )}
                      <span>{isSavingDraft ? "Saving..." : "Save draft"}</span>
                    </button>
                    <button
                      className={`primary${
                        isSendingInvoice ? " is-loading btn-loading" : ""
                      }`}
                      type="button"
                      disabled={isSavingDraft || isSendingInvoice}
                      onClick={handleEmailQuotation}
                    >
                      {isSendingInvoice ? (
                        <span className="btn-spinner" />
                      ) : (
                        <LuSend />
                      )}
                      <span>
                        {isSendingInvoice
                          ? isInvoiceSent
                            ? "Resending..."
                            : "Sending..."
                          : sendInvoiceLabel}
                      </span>
                    </button>
                  </div>
                </div>
                <div className="quotation-editor-header-details">
                  <p className="quotation-editor-subtitle">
                    <strong>{organisation}</strong>
                    <span aria-hidden="true">·</span>
                    <span>All amounts in {currencyCode || "AUD"}</span>
                  </p>
                  <span className="quotation-meta-attribution">
                    <span>
                      Created by{" "}
                      <strong>{values.createdByName || currentUser}</strong>
                    </span>
                    <span aria-hidden="true">·</span>
                    <time>{formattedCreationDate}</time>
                  </span>
                </div>
                {draftSaveError && (
                  <span className="quotation-field-error" role="alert">
                    {draftSaveError}
                  </span>
                )}
              </header>

              <section
                className={`invoice-import-card invoice-import-card--${invoiceImport.status}`}
                aria-live="polite"
              >
                <div className="invoice-import-card__icon">
                  <LuUpload aria-hidden="true" />
                </div>
                <div className="invoice-import-card__content">
                  <strong>Upload an existing invoice</strong>
                  <span>
                    PDF, PNG, JPEG or WEBP · up to 20 MB. Extracted details are
                    added to this draft for review.
                  </span>
                  {invoiceImport.status !== "idle" && (
                    <div className="invoice-import-card__result">
                      <b>{invoiceImport.fileName}</b>
                      <span>{invoiceImport.message}</span>
                      {invoiceImport.warnings.length > 0 && (
                        <ul>
                          {invoiceImport.warnings.map((warning, index) => (
                            <li key={`${warning}-${index}`}>{warning}</li>
                          ))}
                        </ul>
                      )}
                      {invoiceImport.requestId && (
                        <small>Import ID: {invoiceImport.requestId}</small>
                      )}
                    </div>
                  )}
                </div>
                <div className="invoice-import-card__actions">
                  <button
                    className="invoice-import-card__camera"
                    type="button"
                    disabled={invoiceImport.status === "loading" || finalise}
                    onClick={() => invoiceCameraInputRef.current?.click()}
                  >
                    <LuCamera aria-hidden="true" />
                    Take photo
                  </button>
                  <button
                    type="button"
                    disabled={invoiceImport.status === "loading" || finalise}
                    onClick={() => invoiceImportInputRef.current?.click()}
                  >
                    <LuUpload aria-hidden="true" />
                    {invoiceImport.status === "loading"
                      ? "Reading invoice…"
                      : "Choose invoice"}
                  </button>
                </div>
                <input
                  ref={invoiceImportInputRef}
                  type="file"
                  aria-label="Upload invoice"
                  accept="application/pdf,image/png,image/jpeg,image/webp,.pdf,.png,.jpg,.jpeg,.webp"
                  onChange={handleExistingInvoiceUpload}
                  disabled={invoiceImport.status === "loading" || finalise}
                />
                <input
                  ref={invoiceCameraInputRef}
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  capture="environment"
                  onChange={handleExistingInvoiceUpload}
                  disabled={invoiceImport.status === "loading" || finalise}
                />
              </section>

              <InlineFormMessage scope="global" />

              <p className="invoice-editor-intro">
                Save draft keeps your edits without sending anything. Save the
                draft to preview the invoice and download its PDF.
              </p>
              {draftDocument.canUseDocumentActions && (
                <div className="invoice-source-banner">
                  <LuFileText />
                  <div>
                    <strong>Draft saved</strong>
                    <span>
                      {values.quotationID
                        ? `Created from ${
                            values.quotationNumber || "quotation"
                          }. `
                        : ""}
                      No email has been sent and no payment has been recorded.
                    </span>
                  </div>
                </div>
              )}
              {values.quotationID &&
                [
                  !draftDocument.canUseDocumentActions,
                  !hasStartedInvoiceImport,
                ].every(Boolean) && (
                  <div className="invoice-source-banner">
                    <LuFileText />
                    <div>
                      <strong>
                        Creating from {values.quotationNumber || "quotation"}
                      </strong>
                      <span>
                        Customer, items, pricing and notes have been carried
                        over from the approved quote.
                      </span>
                    </div>
                  </div>
                )}

              <div className="invoice-editor-grid">
                <div className="invoice-editor-column">
                  <section className="invoice-flow-card">
                    <h2>Customer &amp; invoice settings</h2>
                    <p>
                      Choose the customer and set the invoice dates and payment
                      terms.
                    </p>
                    <div className="invoice-fields two">
                      <label>
                        Customer
                        <InvoiceSelect
                          dark={darkMode}
                          contactType="customer"
                          className="invoice-customer-search"
                          aria-label="Customer"
                          id="invoice-customer-input"
                          autoComplete="off"
                          aria-invalid={contactNameErr}
                          errorMessage={
                            contactNameErr ? "Please select a customer." : ""
                          }
                          open={isCustomerDropdownOpen}
                          onOpenChange={setIsCustomerDropdownOpen}
                          value={values.contactID || ""}
                          displayValue={
                            !values.contactID ? values.name : undefined
                          }
                          disabled={finalise}
                          onEditOption={
                            canManageCustomers
                              ? (id) => handleCustomerAction("edit", id)
                              : undefined
                          }
                          onChange={(event) => {
                            const option = customerOptions.find(
                              (item) => item.value === event.target.value
                            );
                            handleChangeCustomer("name")(event, option);
                          }}
                        >
                          <option value="" hidden={showAddNewCustomer}>
                            Search customers…
                          </option>
                          {customerOptions.map((option) => (
                            <option
                              key={option.value}
                              value={option.value}
                              disabled={option.disabled}
                              data-description={[option.email, option.unavailableReason].filter(Boolean).join(" · ")}
                            >
                              {option.label}
                            </option>
                          ))}
                        </InvoiceSelect>
                      </label>
                      <label>
                        Recipient email
                        <input
                          id="invoice-recipient-email"
                          type="email"
                          aria-invalid={Boolean(
                            draftValidationField ===
                              "invoice-recipient-email" &&
                              draftRecipientEmailError
                          )}
                          value={
                            values.recipientEmail !== undefined &&
                            values.recipientEmail !== null
                              ? values.recipientEmail
                              : selectedCustomer?.emailAddress || ""
                          }
                          onChange={(e) => {
                            setValues((prev) => ({
                              ...prev,
                              recipientEmail: e.target.value,
                            }));
                          }}
                          placeholder="accounts@example.com"
                        />
                        {draftValidationField === "invoice-recipient-email" &&
                          draftRecipientEmailError && (
                            <span
                              className="quotation-field-error"
                              role="alert"
                            >
                              {draftRecipientEmailError}
                            </span>
                          )}
                      </label>
                    </div>
                    <label>
                      Job / project / PO reference
                      <input
                        value={values.purchaseOrderNumber || ""}
                        onChange={handleChange("purchaseOrderNumber")}
                        placeholder="Add a reference"
                      />
                    </label>
                    <div className="invoice-fields two invoice-date-fields">
                      <label>
                        Invoice number
                        <input
                          id="invoice-number-input"
                          aria-invalid={Boolean(invoiceNoErr || numberValidation.error)}
                          aria-describedby={invoiceNoErr || numberValidation.error ? "invoice-number-error" : undefined}
                          value={values.invoiceNumber || ""}
                          placeholder={
                            invoiceNumber.loading
                              ? "Loading invoice number..."
                              : "Invoice number"
                          }
                          maxLength={100}
                          readOnly={finalise}
                          disabled={isSavingDraft || isSendingInvoice}
                          onChange={(event) => {
                            setInvoiceNoErr(false);
                            numberValidation.clearError();
                            invoiceNumber.onChange(event);
                          }}
                        />
                        {(invoiceNoErr || numberValidation.error) && (
                          <span id="invoice-number-error" className="quotation-field-error" role="alert">
                            {numberValidation.error || "Please enter an invoice number"}
                          </span>
                        )}
                      </label>
                      <div className="invoice-date-picker-field">
                        <PickDate
                          label="Invoice date"
                          id="invoice-date-input"
                          error={Boolean(
                            draftValidationField === "invoice-date-input" &&
                              draftDateError
                          )}
                          helperText={
                            draftValidationField === "invoice-date-input"
                              ? draftDateError
                              : ""
                          }
                          toggleCalendarOnIconClick
                          selected={
                            values.invoiceDate
                              ? new Date(values.invoiceDate)
                              : null
                          }
                          onChange={(date) => handleDateChange(date)}
                          disabled={
                            values.invoiceType === "Through Quotation" ||
                            finalise
                          }
                        />
                      </div>
                      <label className="invoice-date-follow-up">
                        Payment terms
                        <InvoiceSelect
                          dark={darkMode}
                          aria-label="Payment terms"
                          value={values.dueUpto || ""}
                          onChange={handleValidUpto("dueUpto")}
                        >
                          <option value="">Select payment terms</option>
                          {paymentTermsOptions.map((option) => (
                            <option key={option}>{option}</option>
                          ))}
                        </InvoiceSelect>
                      </label>
                      <label className="invoice-date-follow-up">
                        Calculated due date
                        <input
                          id="invoice-due-date-input"
                          aria-invalid={Boolean(
                            draftValidationField === "invoice-due-date-input" &&
                              draftDueDateError
                          )}
                          value={
                            values.dueDate
                              ? dayjs(values.dueDate).format("D MMM YYYY")
                              : "Not yet calculated"
                          }
                          readOnly
                        />
                        {draftValidationField === "invoice-due-date-input" &&
                          draftDueDateError && (
                            <span
                              className="quotation-field-error"
                              role="alert"
                            >
                              {draftDueDateError}
                            </span>
                          )}
                      </label>
                    </div>
                    <small>
                      Due date is calculated from the selected invoice date and
                      payment terms.
                    </small>
                    <button
                      className="invoice-text-action"
                      type="button"
                      onClick={() =>
                        handleChangeCustomer("name")(
                          {},
                          { label: "Add New Customer", value: "add-new" }
                        )
                      }
                    >
                      New customer
                    </button>
                  </section>

                  <section className="invoice-flow-card invoice-items-editor">
                    <div className="invoice-section-title">
                      <div>
                        <h2>Items &amp; pricing</h2>
                        <p>
                          {values.gstType === "No GST"
                            ? "No GST applies to this document."
                            : values.gstType === "Exclusive"
                            ? "Unit prices exclude GST; line totals include GST after discounts."
                            : "Unit prices and line totals include GST after discounts."}
                        </p>
                      </div>
                      <InvoiceSelect
                        dark={darkMode}
                        aria-label="GST pricing basis"
                        value={values.gstType || "Inclusive"}
                        onChange={handleChange("gstType")}
                      >
                        <option value="Inclusive">GST inclusive</option>
                        <option value="Exclusive">GST exclusive</option>
                        <option value="No GST">No GST</option>
                      </InvoiceSelect>
                    </div>
                    <div className="invoice-pricing-basis">
                      Pricing basis{" "}
                      <span>
                        {values.gstType === "No GST"
                          ? "No GST"
                          : values.gstType === "Exclusive"
                          ? "Ex GST"
                          : "Incl GST"}
                      </span>
                    </div>
                    <div className="quotation-items-table-wrapper document-items-aligned">
                      <div className="quotation-items-table-header">
                        <div className="quotation-col-item">Item</div>
                        <div className="quotation-col-qty">Qty</div>
                        <div className="quotation-col-price">Unit price</div>
                        <div className="quotation-col-gst">GST</div>
                        <div className="quotation-col-total">Line total</div>
                        <div className="quotation-col-action" />
                      </div>
                      <div
                        ref={itemsTableBodyRef}
                        className={`quotation-items-table-body${
                          usableRows.length > MAX_VISIBLE_ITEM_ROWS
                            ? " is-scrollable"
                            : ""
                        }`}
                        style={
                          itemsViewportHeight
                            ? { maxHeight: `${itemsViewportHeight}px` }
                            : undefined
                        }
                        data-line-item-list="invoice"
                        tabIndex={
                          usableRows.length > MAX_VISIBLE_ITEM_ROWS
                            ? 0
                            : undefined
                        }
                        aria-label="Invoice items"
                      >
                        {usableRows.map((row, index) => (
                          <div
                            {...itemReorder.getRowProps(
                              index,
                              "quotation-item-row-card document-items-aligned"
                            )}
                            key={index}
                          >
                            <div
                              className="quotation-item-search-row item-picker"
                              ref={(el) =>
                                (itemDropdownRefs.current[index] = el)
                              }
                            >
                              <div className="quotation-item-search-box">
                                <button {...itemReorder.getHandleProps(index)}>
                                  <LuGripVertical />
                                </button>
                                <LuSearch />
                                <ClearableSearchInput
                                  id={`invoice-item-search-${index}`}
                                  aria-invalid={Boolean(
                                    draftValidationAttempted &&
                                      draftItemErrors[index]?.itemName
                                  )}
                                  role="combobox"
                                  aria-label={`Search item for line ${
                                    index + 1
                                  }`}
                                  aria-expanded={
                                    activeItemDropdownIdx === index
                                  }
                                  aria-controls={
                                    activeItemDropdownIdx === index
                                      ? `invoice-item-results-${index}`
                                      : undefined
                                  }
                                  aria-autocomplete="list"
                                  placeholder="Search catalogue item e.g. Safety upgrade"
                                  value={
                                    activeItemDropdownIdx === index
                                      ? itemSearchQueries[index] ??
                                        row.itemName ??
                                        ""
                                      : row.itemName || ""
                                  }
                                  onChange={(event) => {
                                    const next = event.target.value;
                                    setItemSearchQueries((prev) => ({
                                      ...prev,
                                      [index]: next,
                                    }));
                                    handleItemRowChange(
                                      "itemName",
                                      next,
                                      index
                                    );
                                    if (activeItemDropdownIdx !== index)
                                      setActiveItemDropdownIdx(index);
                                  }}
                                  onFocus={() =>
                                    setActiveItemDropdownIdx(index)
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === "Escape")
                                      setActiveItemDropdownIdx(null);
                                  }}
                                />
                                <button
                                  type="button"
                                  className="quotation-item-search-toggle"
                                  aria-haspopup="listbox"
                                  aria-expanded={activeItemDropdownIdx === index}
                                  aria-label={`${
                                    activeItemDropdownIdx === index
                                      ? "Close"
                                      : "Open"
                                  } catalogue item options`}
                                  onClick={() =>
                                    setActiveItemDropdownIdx(
                                      activeItemDropdownIdx === index
                                        ? null
                                        : index
                                    )
                                  }
                                >
                                  <LuChevronDown />
                                </button>
                              </div>

                              {activeItemDropdownIdx === index && (
                                <CatalogueItemDropdown
                                  anchorEl={itemDropdownRefs.current[index]}
                                  onClose={() => setActiveItemDropdownIdx(null)}
                                >
                                  <div
                                    id={`invoice-item-results-${index}`}
                                    className="quotation-item-search-results-list"
                                    role="listbox"
                                    aria-label="Catalogue items"
                                  >
                                    <button
                                      type="button"
                                      role="option"
                                      aria-selected={false}
                                      className="quotation-item-result-card quotation-new-item-option"
                                      onClick={() => {
                                        setItemModalTargetIdx(index);
                                        setActiveItemDropdownIdx(null);
                                        setItemModalError("");
                                        resetNewItemForm(
                                          itemSearchQueries[index] ||
                                            row.itemName ||
                                            ""
                                        );
                                        setIsItemModalOpen(true);
                                      }}
                                    >
                                      <div className="quotation-item-result-top">
                                        <div className="quotation-item-result-name-group">
                                          <LuPlus className="quotation-match-icon" />
                                          <span className="quotation-item-result-name">
                                            Add new item
                                          </span>
                                        </div>
                                      </div>
                                      <p className="quotation-item-result-sub">
                                        Add this item to your catalogue
                                      </p>
                                    </button>
                                    {getMatchingCatalogueItems(
                                      itemSearchQueries[index] ??
                                        row.itemName ??
                                        ""
                                    ).map((item) => {
                                      const isSelected =
                                        row.itemID === item._id ||
                                        (Boolean(row.itemName) &&
                                          row.itemName === item.itemName);
                                      return (
                                        <div
                                          key={item._id}
                                          className="quotation-catalogue-option-row"
                                        >
                                          <button
                                            type="button"
                                            role="option"
                                            aria-selected={isSelected}
                                            className="quotation-autocomplete-item quotation-catalogue-option"
                                            onClick={() =>
                                              handleSelectCatalogueItem(
                                                index,
                                                item
                                              )
                                            }
                                          >
                                            <strong>
                                              {item.itemName ||
                                                item.itemDescription}
                                            </strong>
                                            <span>
                                              {[
                                                item.itemCode,
                                                item.itemDescription ||
                                                  item.itemName,
                                                `GST $${formatCurrencyAUD(
                                                  parseFloat(
                                                    item.itemPrice || 0
                                                  )
                                                )}`,
                                                item.discountValue
                                                  ? `${item.discountValue}% off`
                                                  : null,
                                              ]
                                                .filter(Boolean)
                                                .join(" · ")}
                                            </span>
                                          </button>
                                          <button
                                            type="button"
                                            className="quotation-catalogue-option-edit"
                                            aria-label={`Edit ${
                                              item.itemName || "catalogue item"
                                            }`}
                                            title="Edit item"
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              setActiveItemDropdownIdx(null);
                                              setEditingCatalogueItem({
                                                item,
                                                rowIndex: index,
                                              });
                                            }}
                                          >
                                            <LuPencil aria-hidden="true" />
                                          </button>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </CatalogueItemDropdown>
                              )}
                              {draftValidationAttempted &&
                                draftItemErrors[index]?.itemName && (
                                  <span
                                    id={`invoice-itemName-error-${index}`}
                                    className="quotation-field-error"
                                    role="alert"
                                  >
                                    {draftItemErrors[index].itemName}
                                  </span>
                                )}
                            </div>
                            <div className="quotation-item-details-row">
                              <div
                                className="quotation-col-desc"
                                data-label="Description"
                              >
                                <input
                                  id={`invoice-itemDescription-${index}`}
                                  aria-label={`Description for line ${
                                    index + 1
                                  }`}
                                  value={row.itemDescription || ""}
                                  onChange={(event) =>
                                    handleItemDescription(
                                      "itemDescription",
                                      event.target.value,
                                      index
                                    )
                                  }
                                  placeholder="Add a description"
                                />
                              </div>
                              <div
                                className="quotation-col-qty-input"
                                data-label="Quantity"
                              >
                                <input
                                  id={`invoice-itemQuantity-${index}`}
                                  aria-invalid={Boolean(
                                    draftValidationAttempted &&
                                      draftItemErrors[index]?.itemQuantity
                                  )}
                                  aria-describedby={
                                    draftValidationAttempted &&
                                    draftItemErrors[index]?.itemQuantity
                                      ? `invoice-itemQuantity-error-${index}`
                                      : undefined
                                  }
                                  aria-label={`Quantity for line ${index + 1}`}
                                  type="text"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  maxLength={4}
                                  value={row.itemQuantity ?? ""}
                                  onChange={(event) =>
                                    handleItemRowChange(
                                      "itemQuantity",
                                      event.target.value,
                                      index
                                    )
                                  }
                                  placeholder="Qty"
                                />
                                {draftValidationAttempted &&
                                  draftItemErrors[index]?.itemQuantity && (
                                    <span
                                      id={`invoice-itemQuantity-error-${index}`}
                                      className="quotation-field-error"
                                      role="alert"
                                    >
                                      {draftItemErrors[index].itemQuantity}
                                    </span>
                                  )}
                              </div>
                              <div
                                className="quotation-col-price-input"
                                data-label="Unit price"
                              >
                                <input
                                  id={`invoice-itemPrice-${index}`}
                                  aria-invalid={Boolean(
                                    draftValidationAttempted &&
                                      draftItemErrors[index]?.itemPrice
                                  )}
                                  aria-describedby={
                                    draftValidationAttempted &&
                                    draftItemErrors[index]?.itemPrice
                                      ? `invoice-itemPrice-error-${index}`
                                      : undefined
                                  }
                                  aria-label={`Unit price for line ${
                                    index + 1
                                  }`}
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  value={row.itemPrice || ""}
                                  onChange={(event) =>
                                    handleItemRowChange(
                                      "itemPrice",
                                      event.target.value,
                                      index
                                    )
                                  }
                                  placeholder="0.00"
                                />
                                {draftValidationAttempted &&
                                  draftItemErrors[index]?.itemPrice && (
                                    <span
                                      id={`invoice-itemPrice-error-${index}`}
                                      className="quotation-field-error"
                                      role="alert"
                                    >
                                      {draftItemErrors[index].itemPrice}
                                    </span>
                                  )}
                              </div>
                              <div
                                className="quotation-col-gst-select quotation-custom-dropdown-wrap"
                                data-label="GST"
                              >
                                <InvoiceSelect
                                  dark={darkMode}
                                  aria-label={`GST for ${
                                    row.itemName || `line ${index + 1}`
                                  }`}
                                  disabled={values.gstType === "No GST"}
                                  value={
                                    values.gstType === "No GST"
                                      ? 0
                                      : row.gst ?? 10
                                  }
                                  onChange={(event) =>
                                    handleItemRowChange(
                                      "gst",
                                      event.target.value,
                                      index
                                    )
                                  }
                                >
                                  <option value="10">10%</option>
                                  <option value="0">0%</option>
                                </InvoiceSelect>
                              </div>
                              <div
                                className="quotation-col-line-total"
                                data-label="Line total"
                              >
                                <span>
                                  ${formatCurrencyAUD(row.totalItemPrice || 0)}
                                </span>
                              </div>
                              <div className="quotation-col-row-action">
                                {(index > 0 ||
                                  row.itemID ||
                                  row.itemName?.trim() ||
                                  row.itemDescription?.trim()) && (
                                  <button
                                    type="button"
                                    className="quotation-item-remove-btn"
                                    aria-label={`Remove ${
                                      row.itemName ||
                                      row.itemDescription ||
                                      `line ${index + 1}`
                                    }`}
                                    title="Remove line"
                                    onClick={() => handleRemove(index)}
                                  >
                                    <LuTrash2 />
                                    <span>Remove line</span>
                                  </button>
                                )}
                              </div>
                            </div>
                            <div className="quotation-item-discount-row">
                              <div className="quotation-discount-type-wrap">
                                <label>Discount type</label>
                                <InvoiceSelect
                                  dark={darkMode}
                                  aria-label={`Discount type for ${
                                    row.itemName || `line ${index + 1}`
                                  }`}
                                  value={row.discountType || "None"}
                                  onChange={(event) =>
                                    handleItemRowChange(
                                      "discountType",
                                      event.target.value,
                                      index
                                    )
                                  }
                                >
                                  <option>None</option>
                                  <option>Percentage</option>
                                  <option value="Fixed">Fixed amount</option>
                                </InvoiceSelect>
                              </div>
                              <div
                                className={`quotation-discount-val-wrap${
                                  !row.discountType ||
                                  row.discountType === "None"
                                    ? " disabled"
                                    : ""
                                }`}
                              >
                                <label>Discount value</label>
                                <div className="quotation-input-box">
                                  <input
                                    aria-label={`Discount value for line ${
                                      index + 1
                                    }`}
                                    type="number"
                                    min="0"
                                    step={
                                      row.discountType === "Percentage"
                                        ? "1"
                                        : "0.01"
                                    }
                                    value={
                                      !row.discountType ||
                                      row.discountType === "None"
                                        ? "0.00"
                                        : row.discountValue || ""
                                    }
                                    disabled={
                                      !row.discountType ||
                                      row.discountType === "None"
                                    }
                                    onChange={(event) =>
                                      handleItemRowChange(
                                        "discountValue",
                                        event.target.value,
                                        index
                                      )
                                    }
                                    placeholder={
                                      row.discountType === "Percentage"
                                        ? "%"
                                        : "$0.00"
                                    }
                                  />
                                </div>
                              </div>
                              <div className="quotation-account-wrap">
                                <label>Account</label>
                                <InvoiceSelect
                                  dark={darkMode}
                                  aria-label={`Account for ${
                                    row.itemName || `line ${index + 1}`
                                  }`}
                                  value={row.categoryCodeName || ""}
                                  onChange={(event) =>
                                    handleItemRowChange(
                                      "categoryCodeName",
                                      event.target.value,
                                      index
                                    )
                                  }
                                >
                                  <option value="">None</option>
                                  {catalogueAccountOptions.map((account) => (
                                    <option
                                      key={account.value}
                                      value={account.value}
                                    >
                                      {account.label}
                                    </option>
                                  ))}
                                </InvoiceSelect>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="quotation-items-actions-bar">
                      <button
                        type="button"
                        className="quotation-action-outline-btn"
                        onClick={handleAddLineRow}
                      >
                        <LuPlus />
                        <span>Add line</span>
                      </button>
                      <button
                        type="button"
                        className="quotation-action-link-btn"
                        onClick={handleAddNewItem}
                      >
                        <LuPlus />
                        <span>New catalogue item</span>
                      </button>
                      <div className="quotation-items-spacer" />
                      <div className="quotation-total-discounts" aria-live="polite">
                        <span>Total item discounts</span>
                        <strong>
                          ${formatCurrencyAUD(values.totalDiscountAmount || 0)}
                        </strong>
                      </div>
                    </div>
                    <p className="quotation-field-footnote">
                      {values.gstType === "No GST"
                        ? "No GST applies to this invoice."
                        : values.gstType === "Exclusive"
                        ? "GST is calculated after discounts and added to the line totals."
                        : "GST is extracted after discounts from GST-inclusive prices and is not added again."}
                    </p>
                  </section>

                  <section className="invoice-flow-card">
                    <h2>Notes &amp; terms</h2>
                    <p>These details appear on the customer’s invoice.</p>
                    <div className="invoice-fields invoice-notes-fields">
                      <label>
                        Scope / customer notes
                        <textarea
                          value={values.scopeNotes || ""}
                          onChange={handleChange("scopeNotes")}
                          placeholder="Add scope or customer-facing notes"
                        />
                      </label>
                      <label>
                        Invoice notes
                        <textarea
                          value={values.terms || ""}
                          onChange={handleChange("terms")}
                          placeholder="Add invoice notes"
                        />
                      </label>
                    </div>
                  </section>
                  <section className="invoice-flow-card quotation-attachments-card">
                    <h2>Attachments</h2>
                    <div className="invoice-attachment-box">
                      <div>
                        <strong>
                          {quoDocuments.length
                            ? `${quoDocuments.length} attachment(s)`
                            : "No attachments added"}
                        </strong>
                        <p>
                          Optional supporting files. The invoice PDF is
                          separate.
                        </p>
                      </div>
                    </div>
                    {quoDocuments.length > 0 && (
                      <div className="quotation-attachments-list invoice-attachment-list">
                        {quoDocuments.map((document) => (
                          <div
                            key={document._id}
                            className="quotation-attachment-item"
                          >
                            <span className="quotation-attachment-info">
                              <LuFileText aria-hidden="true" />
                              <span>{document.documentName}</span>
                            </span>
                            <div className="quotation-attachment-actions">
                              <button
                                type="button"
                                className="quotation-attachment-view-btn"
                                aria-label={`View ${document.documentName}`}
                                title="View document"
                                onClick={() => setPreviewAttachment(document)}
                              >
                                <LuEye aria-hidden="true" />
                              </button>
                              <button
                                type="button"
                                className="quotation-attachment-remove-btn"
                                aria-label={`Remove ${document.documentName}`}
                                disabled={loading}
                                onClick={() => handleDeleteDocument(document)}
                              >
                                <LuTrash2 aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <label className="invoice-upload-button">
                      <LuUpload aria-hidden="true" />
                      Add attachment
                      <input
                        type="file"
                        disabled={loading}
                        onChange={saveFile}
                      />
                    </label>
                    {fileError && (
                      <p className="quotation-field-error" role="alert">
                        {fileError}
                      </p>
                    )}
                  </section>
                  <section className="invoice-flow-card">
                    <h2>Payment instructions</h2>
                    <label>
                      Payment instructions
                      <textarea
                        value={values.paymentInstruction || ""}
                        onChange={handleChange("paymentInstruction")}
                        placeholder="No payment instructions configured"
                      />
                    </label>
                    <small>
                      Only configured instructions will appear on the invoice.
                    </small>
                  </section>
                </div>

                <aside className="invoice-editor-aside">
                  <section className="invoice-flow-card invoice-total-card">
                    <div>
                      <h2>Draft total</h2>
                      <LuFileText />
                    </div>
                    <strong>
                      ${formatCurrencyAUD(values.finalAmount || 0)}
                    </strong>
                    <p>{currencyCode || "AUD"} · Draft · Not collectible</p>
                  </section>
                  <div className="quotation-sidebar-doc-actions">
                    <button
                      className="quotation-sidebar-save-btn"
                      type="button"
                      disabled={isSavingDraft || isSendingInvoice}
                      aria-label="Save draft from summary"
                      aria-busy={isSavingDraft || undefined}
                      onClick={() => handleSaveInvoice("draft")}
                    >
                      {isSavingDraft ? (
                        <span className="btn-spinner" />
                      ) : (
                        <LuSave aria-hidden="true" />
                      )}
                      <span>{isSavingDraft ? "Saving..." : "Save draft"}</span>
                    </button>
                    <button
                      className="quotation-sidebar-preview-btn"
                      type="button"
                      disabled={!canPreview}
                      onClick={handlePreviewInvoice}
                    >
                      <LuFileText />
                      <span>Preview invoice</span>
                    </button>
                    <button
                      className="quotation-sidebar-download-btn"
                      type="button"
                      disabled={!canPreview || isDownloadingPdf}
                      onClick={handleDownloadInvoice}
                    >
                      {isDownloadingPdf ? (
                        <span className="btn-spinner" />
                      ) : (
                        <LuDownload />
                      )}
                      <span>
                        {isDownloadingPdf ? "Downloading..." : "Download PDF"}
                      </span>
                    </button>
                    {!canPreview && (
                      <p className="quotation-sidebar-doc-hint" role="status">
                        <LuInfo aria-hidden="true" />
                        <span>
                          {isSavingDraft
                            ? "Saving draft. Preview and Download PDF will be available when saving finishes."
                            : `Save ${
                                draftDocument.hasSavedDocument
                                  ? "your changes"
                                  : "the draft"
                              } to preview the invoice and download its PDF.`}
                        </span>
                      </p>
                    )}
                  </div>
                  <section className="invoice-flow-card invoice-summary-card">
                    <h2>Invoice summary</h2>
                    <p>
                      <span>Subtotal excluding GST</span>
                      <strong>
                        ${formatCurrencyAUD(values.totalAmount || 0)}
                      </strong>
                    </p>
                    <p>
                      <span>
                        {values.gstType === "No GST"
                          ? "Total discounts"
                          : `Total discounts (${
                              values.gstType === "Inclusive"
                                ? "GST inclusive"
                                : "ex GST"
                            })`}
                      </span>
                      <strong>
                        ${formatCurrencyAUD(values.totalDiscountAmount || 0)}
                      </strong>
                    </p>
                    <p>
                      <span>
                        {values.gstType === "No GST"
                          ? "No GST"
                          : `GST 10% (${
                              values.gstType === "Inclusive"
                                ? "included"
                                : "added"
                            })`}
                      </span>
                      <strong>
                        ${formatCurrencyAUD(values.totalGSTAmount || 0)}
                      </strong>
                    </p>
                    <hr />
                    <p className="grand">
                      <span>
                        {values.gstType === "No GST"
                          ? "Total"
                          : "Total including GST"}
                      </span>
                      <strong>
                        ${formatCurrencyAUD(values.finalAmount || 0)}
                      </strong>
                    </p>
                  </section>
                  <section className="invoice-flow-card invoice-delivery-card">
                    <h2>Not sent to customer</h2>
                    <p>
                      Save draft keeps your edits without sending the customer.
                    </p>
                    <p>
                      Send invoice first saves and validates your entries, then
                      opens recipient and message review.
                    </p>
                    <button
                      type="button"
                      disabled={isSavingDraft || isSendingInvoice}
                      onClick={handleEmailQuotation}
                    >
                      <LuSend />
                      {sendInvoiceLabel}
                    </button>
                  </section>
                  <p className="invoice-draft-footnote">
                    A draft is not issued, paid or collectible. Saving does not
                    add a receivable or record a payment.
                  </p>
                </aside>
              </div>
            </main>
          )}
        </div>
        {isItemModalOpen && (
          <CatalogueItemDialog
            accountOptions={catalogueAccountOptions}
            darkMode={darkMode}
            error={itemModalError}
            isSaving={isItemSaving}
            onChange={(name, value) => {
              setNewItemForm((previous) => ({
                ...previous,
                [name]: value,
                ...(name === "discountType" && value === "None"
                  ? { discountValue: "" }
                  : {}),
              }));
              if (itemModalError === name) setItemModalError("");
            }}
            onClose={() => {
              setIsItemModalOpen(false);
              setItemModalTargetIdx(null);
            }}
            onSubmit={handleQuickCreateItem}
            submitLabel="Save & add to invoice"
            values={newItemForm}
          />
        )}
        {editingCatalogueItem && (
          <AddItemDialog
            key={editingCatalogueItem.item._id}
            accountOptions={catalogueAccountOptions}
            businessUserID={loginDetails?.businessUserID}
            darkMode={darkMode}
            item={editingCatalogueItem.item}
            onClose={() => setEditingCatalogueItem(null)}
            onSaved={handleCatalogueItemUpdated}
          />
        )}
        {showBillingModal && (
          <BillingModal
            open={showBillingModal}
            handleConfirm={() => navigate("/subscriptions")}
            handleCancel={() => setShowBillingModal(false)}
            closeModalClick={() => setShowBillingModal(false)}
            message={genericMessage.billingMsg}
            title={genericMessage.noCreditAvailableTitle}
          />
        )}
        {open && (
          <SendInvoiceModal
            open={open}
            onClose={() => setOpen(false)}
            invoiceNumber={values.invoiceNumber}
            customerName={previewCustomerName}
            customerEmail={
              values.recipientEmail ||
              selectedCustomer?.emailAddress ||
              selectedCustomer?.customerEmailAddress ||
              selectedCustomer?.email ||
              ""
            }
            customerEmails={templateValues?.customerEmailAddress}
            invoiceDate={values.invoiceDate}
            dueDate={values.dueDate}
            currency={currencyCode || "AUD"}
            finalAmount={values.finalAmount}
            organisation={organisation}
            invoiceStatus={values.invoiceStatus || "Saved draft"}
            templateData={templateValues}
            onSend={handleSend}
            onViewInvoice={() => {
              setOpen(false);
              navigate(
                savedTargetId ? `/invoices/view/${savedTargetId}` : `/invoices`
              );
            }}
            onEditRecipient={() => {
              setOpen(false);
              window.requestAnimationFrame(() => {
                const input = document.getElementById(
                  "invoice-recipient-email"
                );
                input?.focus({ preventScroll: true });
                input?.scrollIntoView({ behavior: "smooth", block: "center" });
              });
            }}
            darkMode={darkMode}
            mode="send"
          />
        )}
        <InvoiceAttachmentPreview
          attachment={previewAttachment}
          onClose={() => setPreviewAttachment(null)}
          quotationStyle
        />
        <RecordInvoicePaymentDialog
          open={paymentDialogOpen}
          onClose={() => setPaymentDialogOpen(false)}
          onRecorded={loadInvoiceDetails}
          invoice={{ ...values, _id: InvoiceID || values.invoiceID }}
          outstanding={editOutstanding}
          totalPaid={Number(values.finalAmount || 0) - editOutstanding}
          currency={currencyCode || "AUD"}
          dispatch={dispatch}
        />
        <LoadingModal
          loading={loading}
          type="editor"
          variant="document"
          label="Loading invoice…"
        />
        {customerAction && canManageCustomers && (
          <InvoiceCustomerDialog
            key={`${customerAction.action}-${
              customerAction.contact?._id || "new"
            }`}
            action={customerAction.action}
            contact={
              customerAction.contact ||
              (customerAction.action === "create" && !values.contactID
                ? {
                    companyName: values.name,
                    emailAddress: values.recipientEmail,
                  }
                : null)
            }
            businessUserID={loginDetails?.businessUserID}
            darkMode={darkMode}
            onClose={() => setCustomerAction(null)}
            onCreated={handleCustomerCreated}
            onUpdated={handleCustomerUpdated}
            onDeleted={handleCustomerDeleted}
          />
        )}
      </div>
    );
  }

  return (
    <DashboardLayout>
      {unsavedChanges.dialog}
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName={screenName} />
          <Grid container px={2} mt={2} spacing={2}>
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={4}>
              <Autocomplete
                id="customerName-select"
                options={customerOptions}
                // options={[
                //   { label: 'Add New Customer', value: 'add-new' },
                //   ...contactDetails.map(contact => ({ label: contact.companyName, value: contact._id }))]}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.value}
                    className={
                      darkMode
                        ? `${
                            option.value === "add-new"
                              ? "dropDownDefaultHighlight"
                              : "autoCompleteDarkList"
                          }`
                        : `${
                            option.value === "add-new"
                              ? "dropDownDefaultHighlight"
                              : "autoCompleteList"
                          }`
                    }
                  >
                    {option.label}
                  </li>
                )}
                filterOptions={(options, state) => {
                  const filtered = options.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                  );

                  if (
                    showAddNewCustomer &&
                    !filtered.some((option) => option.value === "add-new")
                  ) {
                    filtered.unshift({
                      label: "Add New Customer",
                      value: "add-new",
                    });
                  }

                  return filtered;
                }}
                // filterOptions={(options, state) => {
                //   const filtered = options.filter(option =>
                //     option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                //   );
                //   if (!filtered.some(option => option.value === 'add-new')) {
                //     filtered.unshift({ label: 'Add New', value: 'add-new' }); // Ensure 'Add New' is always in the filtered list
                //   }
                //   return filtered;
                // }}

                onChange={handleChangeCustomer("name")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") {
                    return true;
                  }
                  return option.value === value;
                }}
                value={
                  (values.contactID &&
                    contactDetails.find(
                      (contact) => contact._id === values.contactID
                    )?.companyName) ||
                  (new URLSearchParams(window.location.search).get(
                    "contact"
                  ) === "add-new"
                    ? "Add New Customer"
                    : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="ress"
                    label="Customer"
                    autoFocus={true}
                    placeholder="Enter here"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 25, // <-- ⭐ Max 25 characters
                    }}
                  />
                )}
                disabled={
                  values.invoiceType === "Through Quotation" || finalise
                }
              />

              {contactNameErr ? (
                <p style={errMsg}>Please Select Customer</p>
              ) : (
                ""
              )}
            </Grid>

            <Grid item lg={3} xs={6}>
              <PickDate
                selected={new Date(values.invoiceDate)}
                onChange={handleDateChange}
                label="Invoice Date"
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                minDate={new Date()}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Due Upto</InputLabel>
                <Select
                  labelId="dueUpto-label"
                  label="Due Upto"
                  style={{ height: "35px" }}
                  onChange={handleValidUpto("dueUpto")}
                  value={values.dueUpto}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    Select Due Upto
                  </MenuItem>
                  {paymentTermsOptions.map((option, index) => (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={3} xs={12}>
              <PickDate
                selected={new Date(values.dueDate)}
                onChange={handleDueDateChange}
                label="Due Date"
                minDate={new Date(values.invoiceDate)}
              />
            </Grid>

            {/* Quotation Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Number"
                variant="outlined"
                disabled
                fullWidth
                inputProps={{
                  maxLength: 12,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                value={values.invoiceNumber}
              />
              {invoiceNoErr ? (
                <p style={errMsg}>Quotation Number can't be blank.</p>
              ) : (
                ""
              )}
            </Grid>
            {/* Invoice Type */}
            <Grid item lg={1.5} xs={3}>
              <FormControl fullWidth>
                <InputLabel id="daysHours-select-label">
                  Invoice Type
                </InputLabel>
                <Select
                  labelId="daysHours-select-label"
                  id="daysHours-select"
                  style={{ height: "35.11px" }}
                  label="Invoice Type"
                  disabled={InvoiceID ? true : false}
                  onChange={handleChange("invoiceType")}
                  value={values.invoiceType}
                  autoFocus={true}
                >
                  <MenuItem value="Direct">Direct</MenuItem>
                  {/* <MenuItem value="Through Quotation" >Through Quotation</MenuItem> */}
                  <MenuItem value="Through Quotation">
                    <span
                      style={{
                        width: "100px",
                        whiteSpace: "nowrap",
                        // overflow: "hidden", textOverflow: "ellipsis"
                      }}
                    >
                      Through Quotation
                    </span>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={1.5} xs={3}>
              <Autocomplete
                color="info"
                id="quotation-select"
                options={
                  quotationDetails?.length > 0 &&
                  quotationDetails.map((item) => ({
                    label: item.quotationNumber,
                    id: item._id,
                  }))
                }
                onChange={handleChangeApprovedQuotation("quotationNumber")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") {
                    return true;
                  }
                  return option.value === value;
                }}
                value={
                  (values.quotationID &&
                    quotationDetails.find(
                      (item) => item._id === values.quotationID
                    )?.quotationNumber) ||
                  ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="ress"
                    placeholder="Quotation"
                    label="Quotations"
                    autoFocus={true}
                  />
                )}
                disabled={values.invoiceType === "Direct" || InvoiceID}
              />
            </Grid>

            {/* Reference Number */}
            <Grid item lg={1.5} xs={3}>
              <TextField
                type="text"
                label="Reference Number"
                variant="outlined"
                placeholder="Optional"
                fullWidth
                inputProps={{
                  maxLength: 50,
                  className: "custom-fieldtext",
                }}
                disabled={InvoiceID && finalise}
                value={values.purchaseOrderNumber}
                onChange={handleChange("purchaseOrderNumber")}
              />
            </Grid>
            <Grid item lg={1.5} xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.recurring || false}
                    onChange={(e) =>
                      handleChange("recurring")({
                        target: { value: e.target.checked },
                      })
                    }
                    disabled={finalise}
                  />
                }
                label="Recurring"
              />
            </Grid>

            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="Status"
                  value={values.invoiceStatus}
                  disabled
                  onChange={handleChange("invoiceStatus")}
                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* {showItemAndDocumentSection && <>
            {(typeQuotation && !InvoiceID) && */}
          {/* <Grid item px={2} pt={1} xs={12} md={4} lg={12} >
            <p style={{ fontSize: "14px", fontWeight: "bold", color: "#1A73E8" }} >Invoice Items</p>
          </Grid> */}
          {/* } */}
          <CardContent sx={tableCardStyle}>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={
                typeQuotation && !InvoiceID ? quotationReadOnlyColumns : columns
              }
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>

          <Grid container px={2} style={{ marginTop: "10px" }} spacing={2}>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Base Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(
                  parseFloat(values.totalAmount).toFixed(2)
                )}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total Discount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                // value={values.totalDiscountAmount}
                onChange={handleChange("totalDiscountAmount")}
                disabled
                value={parseFloat(values.totalDiscountAmount).toFixed(2)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35px" }}
                  label="GST Type"
                  value={values.gstType || "Inclusive"}
                  onChange={handleChange("gstType")}
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                  <MenuItem value="No GST">No GST</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total GST  (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values.totalGSTAmount)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Final Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(
                  parseFloat(values.finalAmount).toFixed(2)
                )}
                // autoFocus={true}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 100,
                  className: "custom-fieldtext",
                }}
                value={values.paymentInstruction}
                onChange={handleChange("paymentInstruction")}
                // autoFocus={true}
              />
            </Grid>
          </Grid>

          <Grid container pt={2}>
            {InvoiceID && (
              <>
                {scheduleRetention ? (
                  <Grid
                    container
                    mt={2}
                    columnSpacing={4}
                    alignItems="center"
                    display="flex"
                    justifyContent="center"
                    px={2}
                  >
                    <Grid
                      item
                      xs={12}
                      md={4}
                      spacing={2}
                      lg={6}
                      textAlign={"start"}
                      className="plusButton"
                    >
                      <MDTypography
                        variant="button"
                        fontWeight="bold"
                        color="text"
                        sx={{ userSelect: "none", color: "red" }}
                      >
                        Retention Limit Amount (
                        {currencyCode +
                          " " +
                          (
                            parseFloat(values.finalAmount) -
                            parseFloat(usedRetentionAmount)
                          ).toFixed(2) +
                          " / " +
                          parseFloat(values.finalAmount).toFixed(2)}
                        )
                      </MDTypography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={4}
                      spacing={2}
                      lg={6}
                      textAlign={"end"}
                      className="plusButton"
                    >
                      <MDTypography
                        onClick={addNewRetentionRow}
                        variant="button"
                        fontWeight="bold"
                        color="text"
                        sx={{
                          cursor: "pointer",
                          userSelect: "none",
                          ml: -1,
                          color: "#1A73E8",
                        }}
                      >
                        <Add /> Add New Row for Retention
                      </MDTypography>
                    </Grid>
                  </Grid>
                ) : (
                  // <Grid item xs={12} px={2} md={4} lg={2}>
                  //   <Tooltip title="Schedule Retention Link" arrow id="retention" placement="bottom-start">
                  //     <p id="retention" style={{
                  //       fontSize: "14px", fontWeight: "bold",
                  //       color: featureAccess ? "#008000" : "#d3d3d3", textDecoration: "underline", cursor: "pointer"
                  //     }}
                  //       onClick={handleRetentionClick} >
                  //       Schedule Retention
                  //     </p>
                  //   </Tooltip>
                  // </Grid>
                  <Grid item xs={12} px={2} md={4} lg={2}>
                    <Tooltip
                      title="Click to schedule retention"
                      arrow
                      placement="bottom-start"
                    >
                      {/* Old Code Commented by Anuj 17-12-2025  */}
                      {/* <span style={{ cursor: "pointer" }} onClick={handleRetentionClick}>
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: featureAccess ? "#008000" : "#d3d3d3",
                            textDecoration: "underline",
                            margin: 0
                          }}
                        >
                          Schedule Retention
                        </p>
                      </span> */}
                      {/* New Code Created by Anuj 17-12-2025  */}

                      <Box component="span">
                        <Box
                          component="span"
                          onClick={handleRetentionClick}
                          sx={{
                            fontSize: "14px !important",
                            fontWeight: "bold",
                            color: featureAccess ? "#008000" : "#d3d3d3",
                            textDecoration: "underline",
                            cursor: "pointer", // ✅ always pointer
                            position: "relative",
                            zIndex: 10,
                          }}
                        >
                          Schedule Retention
                        </Box>
                      </Box>
                    </Tooltip>
                  </Grid>
                )}
              </>
            )}
          </Grid>

          {scheduleRetention && retentionItemValues.length > 0 && (
            <Grid container pt={2}>
              <CardContent sx={tableCardStyle}>
                <DataTable
                  theme={darkMode ? "solarized" : "light"}
                  columns={columnRetention}
                  data={retentionItemValues}
                  customStyles={customStyles}
                  fixedHeaderScrollHeight="185px"
                  fixedHeader={true}
                />
              </CardContent>
            </Grid>
          )}
          {InvoiceID && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={12}>
                <Button onClick={() => setExpanded(!expanded)}>
                  <Badge
                    badgeContent={quoDocuments.length}
                    sx={{
                      ".MuiBadge-badge": {
                        backgroundColor: tableBorder,
                        color: "#ffffff",
                      },
                    }}
                    showZero
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        border: darkMode
                          ? "1px solid white"
                          : `1px solid ${tableBorder}`,
                        borderRadius: "5px",
                        color: darkMode ? "white" : tableBorder,
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "-9px",
                        padding: "1px 10px",
                        fontSize: "12px",
                      }}
                    >
                      Attached Document
                      {expanded ? (
                        <ArrowDropDown
                          className="arrowdropdown"
                          style={{ marginLeft: "5px" }}
                        />
                      ) : (
                        <ArrowDropUpIcon
                          className="arrowdropdown"
                          style={{ marginLeft: "5px" }}
                        />
                      )}
                    </Typography>
                  </Badge>
                </Button>
              </Grid>
            </Grid>
          )}
          {expanded && (
            <>
              {(!typeQuotation || InvoiceID) && (
                <>
                  <Grid container spacing={2} px={2} pt={2}>
                    {/* <Grid item lg={3} xs={4}>
                      <TextField
                        type="text"
                        label="Document Name"
                        placeholder="Document Name"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 30,
                          className: "custom-fieldtext"
                        }}
                        value={values.documentName}
                        onChange={handleChange('documentName')}
                        disabled
                      // autoFocus={true}
                      />
                    </Grid> */}
                    <Grid item xs={12} lg={4}>
                      <label htmlFor="fileInput">
                        <TextField
                          id="invoiceDocuments"
                          type="text"
                          label="Document File"
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            readOnly: true,
                            className: "uploadfile",
                            startAdornment: (
                              <InputAdornment position="start">
                                <label className="ress" htmlFor="fileInput">
                                  <Button
                                    component="span"
                                    size="small"
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "-19px",
                                      color: `${
                                        darkMode ? "white" : tableBorder
                                      }`,
                                      textDecoration: "2px solid underline",
                                    }}
                                    // onClick={() => { !values.documentName && (showResMsg(`Please enter Document Name`, 1000, false)) }}
                                  >
                                    Choose File
                                  </Button>
                                </label>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <input
                          type="file"
                          // accept="image/*,.pdf,.docx,.doc,application/vnd.ms-excel,text/csv"
                          id="fileInput"
                          style={{ display: "none" }}
                          // disabled={!values.documentName}
                          onChange={saveFile}
                        />
                      </label>
                      <p style={errMsg}>{fileError}</p>
                    </Grid>
                  </Grid>
                </>
              )}

              {quoDocuments.length > 0 && (
                <CardContent sx={tableCardStyle}>
                  <DataTable
                    theme={darkMode ? "solarized" : "light"}
                    columns={documentColumns}
                    data={quoDocuments}
                    fixedHeaderScrollHeight="185px"
                    fixedHeader={true}
                    customStyles={customStyles}
                  />
                </CardContent>
              )}
            </>
          )}
          {/* </>
          } */}
          {showSendEmailBtn && showInvoicePaymentLink && (
            <Grid item px={2} pt={1} xs={6} md={4} lg={3}>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#008000",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={handleRedirectToPaymentScreen}
              >
                Record Part Payment
              </span>
            </Grid>
          )}

          <Grid
            container
            mt={2}
            pb={3}
            // columnSpacing={{ xs: 2, md: 4, lg: 4 }}
            // columnSpacing={4}
            alignItems="center"
            spacing={2}
            style={{ display: "flex", justifyContent: "center" }}
            className="gridbuttons"
          >
            <Grid item xs={12} md={4} lg={1.68}>
              {/* <Link to={routePath}> */}
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ height: "40px" }}
                onClick={handleCancel}
              >
                Close
              </MDButton>
              {/* </Link> */}
            </Grid>
            <Grid item xs={12} md={4} lg={1.68}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                style={{ height: "40px" }}
                loading={isSavingDraft}
                loadingLabel={InvoiceID ? "Updating..." : "Saving..."}
                disabled={isSavingDraft || isSendingInvoice}
                onClick={() => handleSaveInvoice("draft")}
              >
                {InvoiceID ? (type !== "clone" ? "Update" : "Clone ") : "Save"}
              </MDButton>
            </Grid>
            {InvoiceID && (
              <Grid
                item
                xs={12}
                md={4}
                spacing={2}
                lg={1.68}
                style={{
                  cursor: `${canSendInvoice ? "pointer" : "not-allowed"}`,
                }}
              >
                <MDButton
                  rel="noreferrer"
                  variant="gradient"
                  color="info"
                  fullWidth
                  style={{ height: "40px" }}
                  loading={isSendingInvoice}
                  loadingLabel="Sending..."
                  disabled={
                    !canSendInvoice || isSavingDraft || isSendingInvoice
                  }
                  onClick={handleEmailQuotation}
                >
                  {isInvoiceSent ? "Resend Email" : "Send Email"}
                </MDButton>
              </Grid>
            )}
          </Grid>
        </Card>
      </div>

      {viewDocumentInModal && (
        <Modal
          className="document-preview-overlay"
          open={viewDocumentInModal}
          onClose={handleCloseViewModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            "& .MuiModal-root": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <Card
            sx={
              darkMode
                ? {
                    ...pdfStyle,
                    border: "none",
                    width: { xs: "95%", sm: "90%", md: "80%" },
                    maxWidth: "1200px",
                    background: "black",
                  }
                : {
                    ...pdfStyle,
                    border: "none",
                    width: { xs: "95%", sm: "90%", md: "80%" },
                    maxWidth: "1200px",
                  }
            }
          >
            <Box>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
              >
                Document Viewer
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  height: { xs: "60vh", sm: "70vh" },
                  overflow: "hidden",
                }}
              >
                {selectedFileType === "image" ? (
                  <img
                    title="Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="100%"
                    style={{
                      display: "block",
                      objectFit: "contain",
                      aspectRatio: "1/1",
                    }}
                    alt="Document Viewer"
                  />
                ) : selectedFileType === "pdf" ? (
                  <iframe
                    title="Quotation Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="650"
                    allowFullScreen
                  ></iframe>
                ) : null}
              </Box>
              <Grid
                container
                id="modal-modal-description"
                sx={{ mt: 2, justifyContent: "center" }}
              >
                <MDButton
                  color="warning"
                  className="modalButton"
                  onClick={() => {
                    setViewDocumentInModal(false);
                  }}
                  sx={{ fontSize: "1rem", padding: "0.5rem 1rem" }}
                >
                  Close
                </MDButton>
              </Grid>
            </Box>
          </Card>
        </Modal>
      )}
      {showBillingModal && (
        <BillingModal
          open={showBillingModal}
          handleConfirm={() => {
            navigate("/subscriptions");
          }}
          handleCancel={() => {
            setShowBillingModal(false);
          }}
          closeModalClick={() => {
            setShowBillingModal(false);
          }}
          message={genericMessage.billingMsg}
          title={genericMessage.noCreditAvailableTitle}
        />
      )}
      {open && (
        <SendInvoiceModal
          open={open}
          onClose={() => setOpen(false)}
          invoiceNumber={values.invoiceNumber}
          customerName={previewCustomerName}
          customerEmail={
            values.recipientEmail ||
            selectedCustomer?.emailAddress ||
            selectedCustomer?.customerEmailAddress ||
            selectedCustomer?.email ||
            ""
          }
          customerEmails={templateValues?.customerEmailAddress}
          invoiceDate={values.invoiceDate}
          dueDate={values.dueDate}
          currency={currencyCode || "AUD"}
          finalAmount={values.finalAmount}
          organisation={organisation}
          invoiceStatus={values.invoiceStatus || "Saved draft"}
          templateData={templateValues}
          onSend={handleSend}
          onViewInvoice={() => {
            setOpen(false);
            navigate(
              savedTargetId ? `/invoices/view/${savedTargetId}` : `/invoices`
            );
          }}
          onEditRecipient={() => {
            setOpen(false);
            window.requestAnimationFrame(() => {
              const input = document.getElementById("invoice-recipient-email");
              input?.focus({ preventScroll: true });
              input?.scrollIntoView({ behavior: "smooth", block: "center" });
            });
          }}
          darkMode={darkMode}
          mode="send"
        />
      )}
      <LoadingModal
        loading={loading}
        type="editor"
        variant="document"
        label="Loading invoice…"
      />
    </DashboardLayout>
  );
}
export default memo(AddInvoice);
